/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ENTRY_DATA_SECTION_KEYS as SECTION_KEYS,
  ENTRY_DATA_DRUG_PROFILE_GROUP_TABLE_KEY as DRUG_PROFILE,
  ENTRY_DATA_DRUG_PROFILE_SHELL_KEYS as DRUG_PROFILE_SHELL_KEYS,
  ENTRY_DATA_KEY_COMMENTS_GROUP_TABLE_KEY as KEY_COMMENT,
  ENTRY_DATA_FUNDED_COMPANY_GROUP_TABLE_KEY as FUNDED_COMPANY,
  ENTRY_DATA_ROUND_TYPE_AND_STATUS_GROUP_TABLE_KEY as ROUND_TYPE_AND_STATUS,
  ENTRY_DATA_FINANCING_INFORMATION_GROUP_TABLE_KEY as FINANCING_INFORMATION,
  ENTRY_DATA_ADDITIONAL_INFORMATION_VENTURE_CAPITAL_GROUP_TABLE_KEY as ADDITIONAL_INFORMATION_VENTURE_CAPITAL,
  ENTRY_DATA_INVESTORS_GROUP_TABLE_KEY as INVESTORS,
  MERGE_ACQUISITION_SHELL_KEYS,
  ENTRY_DATA_RIGHTS_SCOPE_KEYS,
  ENTRY_DATA_LICENSEE_TABLE_KEYS,
  ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS,
  ENTRY_DATA_MILESTONE_PAYMENT_CONDITION_KEYS,
  ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS,
  ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS,
  ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS,
  ENTRY_DATA_SECTION_KEYS,
  ENTRY_DATA_DEAL_TYPE_AND_STATUS,
  ENTRY_DATA_CLINICAL_TRIAL_DESIGN,
  CLINICAL_TRIAL_DESIGN_GROUP_SHELL_KEYS,
  ENTRY_DATA_CLINICAL_TRIAL_DESIGN_KEYS,
  VENTURE_FORMATION_SHELL_KEYS,
  ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS,
} from "@frontend/common";

import {
  DealLaScAdvisorShellKeys,
  DealLaScDealTermsPartnerAxisTableShellKeys,
  DealLaScDealTermsRightsFlowShellKeys,
  DealLaScDealTermsRightsScopeTableShellKeys,
  DealLaScDealTermsSingleTableShellKeys,
  DealLaScMainFinancialTermsTableShellKeys,
  DealLaScMilestonePaymentShellKeys,
  DealLaScOtherPaymentShellKeys,
  DealLaScPartnerAShellKeys,
  DealLaScPartnerBShellKeys,
  DealLaScPartnerCShellKeys,
  DealLaScRoyaltyShellKeys,
} from "@/types/dealLaSc.types";
import {
  DealsAdvisorShellKeys,
  DealTypeAndStatusKey,
} from "@/types/deals.types";
import {
  DrugProfileDefaultShellKey,
  DrugProfileShellKeysOnlyEntryDataValue,
} from "@/types/drugProfile.types";
import {
  ExpeditedProgramContentsGroupShellKey,
  ExpeditedProgramContentsShellKeysNotAttributionId,
  ExpeditedProgramDrugProfileShellKeysNotAttributionId,
  ExpeditedProgramKeyCommentShellKeys,
} from "@/types/expeditedProgram.types";
import {
  EntryDataInvestorValue,
  VentureCapitalAdditionalInformationShellKeys,
  VentureCapitalFinancingInformationShellKeys,
  VentureCapitalFundedCompanyShellKeys,
  VentureCapitalInvestorsShellKeys,
  VentureCapitalRoundTypeAndStatusShellKeys,
} from "@/types/ventureCapital.types";
import { createRandomString } from "@organisms/TableCreatorComment/components/CommentModalContainer/components/CommentModalMessageComposer/utils/createRandomString";

import {
  EXPEDITED_PROGRAM,
  EXPEDITED_PROGRAM_GROUP_KEY as eg,
} from "./expeditedProgramKey.constants";
import { createAttributionId } from "../utils/createAttributionId";

import type { GroupTableKeyType } from "../types/tableCreator.types";
import type { ArticleEntryData } from "@/types/articleEntryData.types";
import type {
  ClinicalTrialDesign1ShellKeysWithoutTrialIntervention,
  ClinicalTrialsClinicalEndpointsDescriptionShellKey,
  ClinicalTrialsClinicalResultsShellKey,
  ClinicalTrialsKeyCommentShellKey,
  DesignGroupInformationShellKey,
  DrugProfileShellKeysNotIncludeAttributionId,
  EndpointsGroupInformation,
  EndpointsValue,
} from "@/types/clinicalTrials.types";
import type {
  ApprovalProcessTypeShellKey,
  QuoteAndSpokesPersonType,
  RegulatoryDrugProfileShellKeysNotAttributionId,
} from "@/types/regulatory.types";

export const TEXTFIELD_PATH_TO_ENTER_ENTRY_DATA: Record<
  string,
  {
    [key in GroupTableKeyType]?: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ArticleEntryData;
  }
> = {
  "Clinical Trials": {
    "Drug Profile": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      "Clinical Trials": {
        ...data["Clinical Trials"],
        "Drug Profile": data["Clinical Trials"]?.["Drug Profile"]?.map(
          (item, index) => {
            if (index === tableIndex) {
              if (shellKey === "Therapeutic Area") {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createRandomString(8),
                  },
                  "Therapeutic Area": {
                    ...item["Therapeutic Area"],
                    attributionId:
                      item["Therapeutic Area"]?.attributionId ||
                      createRandomString(8),
                    value:
                      item["Therapeutic Area"] &&
                      item["Therapeutic Area"]?.value.length > valueIndex
                        ? item["Therapeutic Area"].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item["Therapeutic Area"].value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [shellKey as DrugProfileShellKeysNotIncludeAttributionId]: {
                  ...item[
                    shellKey as DrugProfileShellKeysNotIncludeAttributionId
                  ],
                  attributionId:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.attributionId || createRandomString(8),
                  value:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ] &&
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.value.length > valueIndex
                      ? item[
                          shellKey as DrugProfileShellKeysNotIncludeAttributionId
                        ].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[
                            shellKey as DrugProfileShellKeysNotIncludeAttributionId
                          ].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }
            return item;
          },
        ),
      },
    }),
    [ENTRY_DATA_CLINICAL_TRIAL_DESIGN]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) =>
      ({
        ...data,
        [ENTRY_DATA_SECTION_KEYS.clinicalTrial]: {
          ...data[ENTRY_DATA_SECTION_KEYS.clinicalTrial],
          [ENTRY_DATA_CLINICAL_TRIAL_DESIGN]: data[
            ENTRY_DATA_SECTION_KEYS.clinicalTrial
          ]?.[ENTRY_DATA_CLINICAL_TRIAL_DESIGN]?.map(
            (tableInfo, tableInfoIndex) => {
              if (tableIndex === tableInfoIndex) {
                const clinicalDesign1Data =
                  tableInfo[
                    ENTRY_DATA_CLINICAL_TRIAL_DESIGN_KEYS.clinicalTrialDesign1
                  ];

                const clinicalDesign2Data =
                  tableInfo[
                    ENTRY_DATA_CLINICAL_TRIAL_DESIGN_KEYS.clinicalTrialDesign2
                  ];

                if (
                  groupShellKey ===
                  CLINICAL_TRIAL_DESIGN_GROUP_SHELL_KEYS.clinicalDesign1
                )
                  return {
                    ...tableInfo,
                    [ENTRY_DATA_CLINICAL_TRIAL_DESIGN_KEYS.clinicalTrialDesign1]:
                      {
                        ...clinicalDesign1Data,
                        [shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention]:
                          {
                            ...clinicalDesign1Data[
                              shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                            ],
                            attributionId:
                              clinicalDesign1Data[
                                shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                              ]?.attributionId || createRandomString(8),
                            value:
                              clinicalDesign1Data[
                                shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                              ] &&
                              clinicalDesign1Data[
                                shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                              ]?.value.length > valueIndex
                                ? clinicalDesign1Data[
                                    shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                                  ].value
                                    ?.map((valueItem, valueItemIndex) => {
                                      if (valueItemIndex === valueIndex) {
                                        if (valueText === "") {
                                          return null;
                                        }
                                        return {
                                          text: valueText,
                                          is_modified: true,
                                        };
                                      }

                                      return valueItem;
                                    })
                                    .filter((valueItem) => valueItem !== null)
                                    .filter(
                                      (
                                        valueItem,
                                        valueItemIndex,
                                        valueList,
                                      ) => {
                                        const lastValueIndex =
                                          valueList.findIndex(
                                            (target) =>
                                              target?.text.toLowerCase() ===
                                              valueItem?.text.toLowerCase(),
                                          );
                                        return (
                                          valueItemIndex === lastValueIndex
                                        );
                                      },
                                    )
                                : [
                                    ...clinicalDesign1Data[
                                      shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                                    ].value,
                                    { text: valueText, is_modified: true },
                                  ]
                                    ?.map(
                                      (
                                        valueItem: {
                                          text: string;
                                          is_modified: boolean;
                                        },
                                        valueItemIndex: number,
                                      ) => {
                                        if (valueItemIndex === valueIndex) {
                                          if (valueText === "") {
                                            return null;
                                          }
                                          return {
                                            text: valueText,
                                            is_modified: true,
                                          };
                                        }

                                        return valueItem;
                                      },
                                    )
                                    .filter((valueItem) => valueItem !== null)
                                    .filter(
                                      (
                                        valueItem,
                                        valueItemIndex,
                                        valueList,
                                      ) => {
                                        const lastValueIndex =
                                          valueList.findIndex(
                                            (target) =>
                                              target?.text.toLowerCase() ===
                                              valueItem?.text.toLowerCase(),
                                          );
                                        return (
                                          valueItemIndex === lastValueIndex
                                        );
                                      },
                                    ),
                          },
                      },
                  };

                if (
                  groupShellKey ===
                  CLINICAL_TRIAL_DESIGN_GROUP_SHELL_KEYS.clinicalDesign2
                )
                  return {
                    ...tableInfo,
                    [ENTRY_DATA_CLINICAL_TRIAL_DESIGN_KEYS.clinicalTrialDesign2]:
                      clinicalDesign2Data?.map(
                        (subGroupShellInfo, subGroupShellInfoIndex) => {
                          if (subGroupShellInfoIndex !== subGroupShellIndex)
                            return subGroupShellInfo;
                          if (
                            shellKey === "Arm Name" ||
                            shellKey === "Patients Number"
                          ) {
                            return {
                              ...subGroupShellInfo,
                              [shellKey]: {
                                ...subGroupShellInfo[shellKey],
                                value:
                                  (subGroupShellInfo[shellKey].value || [])
                                    .length > valueIndex
                                    ? (subGroupShellInfo[shellKey].value || [])
                                        .map((shellValue, shellValueIndex) => {
                                          if (shellValueIndex === valueIndex) {
                                            if (valueText === "") {
                                              return null;
                                            }
                                            return {
                                              text: valueText,
                                              is_modified: true,
                                            };
                                          }
                                          return shellValue;
                                        })
                                        .filter(
                                          (shellValue) => shellValue !== null,
                                        )
                                        .filter(
                                          (
                                            valueItem,
                                            valueItemIndex,
                                            valueList,
                                          ) => {
                                            const lastValueIndex =
                                              valueList.findIndex(
                                                (target) =>
                                                  target?.text.toLowerCase() ===
                                                  valueItem?.text.toLowerCase(),
                                              );
                                            return (
                                              valueItemIndex === lastValueIndex
                                            );
                                          },
                                        )
                                    : [
                                        ...(subGroupShellInfo[shellKey].value ||
                                          []),
                                        { text: valueText, is_modified: true },
                                      ]
                                        .map((shellValue, shellValueIndex) => {
                                          if (shellValueIndex === valueIndex) {
                                            if (valueText === "") {
                                              return null;
                                            }
                                            return {
                                              text: valueText,
                                              is_modified: true,
                                            };
                                          }
                                          return shellValue;
                                        })
                                        .filter(
                                          (shellValue) => shellValue !== null,
                                        )
                                        .filter(
                                          (
                                            valueItem,
                                            valueItemIndex,
                                            valueList,
                                          ) => {
                                            const lastValueIndex =
                                              valueList.findIndex(
                                                (target) =>
                                                  target?.text.toLowerCase() ===
                                                  valueItem?.text.toLowerCase(),
                                              );
                                            return (
                                              valueItemIndex === lastValueIndex
                                            );
                                          },
                                        ),
                              },
                            };
                          }

                          return {
                            ...subGroupShellInfo,
                            "Design Group Information": subGroupShellInfo?.[
                              "Design Group Information"
                            ]?.map((shellValueInfo, shellValueIndex) => {
                              if (shellValueIndex !== shellIndex)
                                return shellValueInfo;
                              return {
                                ...shellValueInfo,
                                [shellKey]: {
                                  ...shellValueInfo[
                                    shellKey as DesignGroupInformationShellKey
                                  ],
                                  value:
                                    (
                                      shellValueInfo[
                                        shellKey as DesignGroupInformationShellKey
                                      ].value || []
                                    ).length > valueIndex
                                      ? shellValueInfo[
                                          shellKey as DesignGroupInformationShellKey
                                        ].value
                                          .map((valueInfo, valueInfoIndex) => {
                                            if (valueInfoIndex === valueIndex) {
                                              if (valueText === "") {
                                                return null;
                                              }
                                              return {
                                                text: valueText,
                                                is_modified: true,
                                              };
                                            }
                                            return valueInfo;
                                          })
                                          .filter(
                                            (valueInfo) => valueInfo !== null,
                                          )
                                          .filter(
                                            (
                                              valueItem,
                                              valueItemIndex,
                                              valueList,
                                            ) => {
                                              const lastValueIndex =
                                                valueList.findIndex(
                                                  (target) =>
                                                    target?.text.toLowerCase() ===
                                                    valueItem?.text.toLowerCase(),
                                                );
                                              return (
                                                valueItemIndex ===
                                                lastValueIndex
                                              );
                                            },
                                          )
                                      : [
                                          ...(shellValueInfo[
                                            shellKey as DesignGroupInformationShellKey
                                          ].value || []),
                                          {
                                            text: valueText,
                                            is_modified: true,
                                          },
                                        ]
                                          .map((valueInfo, valueInfoIndex) => {
                                            if (valueInfoIndex === valueIndex) {
                                              if (valueText === "") {
                                                return null;
                                              }
                                              return {
                                                text: valueText,
                                                is_modified: true,
                                              };
                                            }
                                            return valueInfo;
                                          })
                                          .filter(
                                            (valueInfo) => valueInfo !== null,
                                          )
                                          .filter(
                                            (
                                              valueItem,
                                              valueItemIndex,
                                              valueList,
                                            ) => {
                                              const lastValueIndex =
                                                valueList.findIndex(
                                                  (target) =>
                                                    target?.text.toLowerCase() ===
                                                    valueItem?.text.toLowerCase(),
                                                );
                                              return (
                                                valueItemIndex ===
                                                lastValueIndex
                                              );
                                            },
                                          ),
                                },
                              };
                            }),
                          };
                        },
                      ),
                  };
              }

              return tableInfo;
            },
          ),
        },
      } as ArticleEntryData),

    "Clinical Results": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        "Clinical Trials": {
          ...data["Clinical Trials"],
          "Clinical Results": {
            ...data["Clinical Trials"]?.["Clinical Results"],
            [shellKey]: {
              ...data["Clinical Trials"]?.["Clinical Results"]?.[
                shellKey as ClinicalTrialsClinicalResultsShellKey
              ],

              value:
                [
                  ...(data["Clinical Trials"]?.["Clinical Results"]?.[
                    shellKey as ClinicalTrialsClinicalResultsShellKey
                  ].value || []),
                ].length > valueIndex
                  ? data["Clinical Trials"]?.["Clinical Results"]?.[
                      shellKey as ClinicalTrialsClinicalResultsShellKey
                    ].value
                      .map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }
                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(data["Clinical Trials"]?.["Clinical Results"]?.[
                        shellKey as ClinicalTrialsClinicalResultsShellKey
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }
                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData),

    "Clinical Endpoints (Table)": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        "Clinical Trials": {
          ...data["Clinical Trials"],
          "Clinical Endpoints (Table)": data?.["Clinical Trials"]?.[
            "Clinical Endpoints (Table)"
          ]?.map((tableInfo, tableInfoIndex) => {
            if (tableInfoIndex === tableIndex) {
              if (shellKey === "Endpoints Table Notes") {
                return {
                  ...tableInfo,
                  [shellKey]: {
                    ...tableInfo[shellKey],
                    value:
                      valueText !== ""
                        ? [
                            {
                              text: valueText,
                              is_modified: true,
                            },
                          ]
                        : [],
                  },
                };
              }
              return {
                ...tableInfo,
                "Endpoints Table Information": tableInfo?.[
                  "Endpoints Table Information"
                ]?.map((groupShellInfo, groupShellInfoIndex) => {
                  if (
                    shellKey === "Endpoint Classification" ||
                    shellKey === "Endpoint Name including Measurement Timing"
                  ) {
                    if (groupShellInfoIndex !== groupShellIndex)
                      return groupShellInfo;
                    return {
                      ...groupShellInfo,
                      [shellKey]: {
                        ...groupShellInfo[shellKey as keyof EndpointsValue],
                        value:
                          valueText !== ""
                            ? [
                                {
                                  text: valueText,
                                  is_modified: true,
                                },
                              ]
                            : [],
                      },
                    };
                  }
                  if (shellKey === "Group Name") {
                    return {
                      ...groupShellInfo,
                      "Endpoint Group Information": groupShellInfo?.[
                        "Endpoint Group Information"
                      ]?.map((shellInfo, shellInfoIndex) => {
                        if (shellInfoIndex !== shellIndex) return shellInfo;
                        return {
                          ...shellInfo,
                          [shellKey]: {
                            ...shellInfo[
                              shellKey as keyof EndpointsGroupInformation
                            ],
                            value:
                              valueText !== ""
                                ? [
                                    {
                                      text: valueText,
                                      is_modified: true,
                                    },
                                  ]
                                : [],
                          },
                        };
                      }),
                    };
                  }
                  // NOTE : ShellKey === ("Group Data" || "P-Value")
                  if (groupShellInfoIndex !== groupShellIndex)
                    return groupShellInfo;
                  return {
                    ...groupShellInfo,
                    "Endpoint Group Information": groupShellInfo?.[
                      "Endpoint Group Information"
                    ]?.map((shellValueInfo, shellValueIndex) => {
                      if (shellValueIndex !== shellIndex) {
                        return shellValueInfo;
                      }
                      return {
                        ...shellValueInfo,
                        [shellKey]: {
                          ...shellValueInfo[
                            shellKey as keyof EndpointsGroupInformation
                          ],
                          value:
                            valueText !== ""
                              ? [
                                  {
                                    text: valueText,
                                    is_modified: true,
                                  },
                                ]
                              : [],
                        },
                      };
                    }),
                  };
                }),
              };
            }
            return tableInfo;
          }),
        },
      } as ArticleEntryData),

    "Clinical Endpoints (Description)": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        "Clinical Trials": {
          ...data["Clinical Trials"],
          "Clinical Endpoints (Description)": {
            ...data["Clinical Trials"]?.["Clinical Endpoints (Description)"],
            [shellKey]: {
              ...data["Clinical Trials"]?.[
                "Clinical Endpoints (Description)"
              ]?.[
                shellKey as ClinicalTrialsClinicalEndpointsDescriptionShellKey
              ],

              value:
                [
                  ...(data["Clinical Trials"]?.[
                    "Clinical Endpoints (Description)"
                  ]?.[
                    shellKey as ClinicalTrialsClinicalEndpointsDescriptionShellKey
                  ].value || []),
                ].length > valueIndex
                  ? data["Clinical Trials"]?.[
                      "Clinical Endpoints (Description)"
                    ]?.[
                      shellKey as ClinicalTrialsClinicalEndpointsDescriptionShellKey
                    ].value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(data["Clinical Trials"]?.[
                        "Clinical Endpoints (Description)"
                      ]?.[
                        shellKey as ClinicalTrialsClinicalEndpointsDescriptionShellKey
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData),

    "Key Comment": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        "Clinical Trials": {
          ...data["Clinical Trials"],
          "Key Comment": {
            ...data["Clinical Trials"]?.["Key Comment"],
            [shellKey]: {
              ...data["Clinical Trials"]?.["Key Comment"]?.[
                shellKey as ClinicalTrialsKeyCommentShellKey
              ],

              value:
                [
                  ...(data["Clinical Trials"]?.["Key Comment"]?.[
                    shellKey as QuoteAndSpokesPersonType
                  ].value || []),
                ].length > valueIndex
                  ? data["Clinical Trials"]?.["Key Comment"]?.[
                      shellKey as QuoteAndSpokesPersonType
                    ].value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                  : [
                      ...(data["Clinical Trials"]?.["Key Comment"]?.[
                        shellKey as QuoteAndSpokesPersonType
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null),
            },
          },
        },
      } as ArticleEntryData),
  },
  "Clinical Trial Status": {
    "Drug Profile": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      "Clinical Trial Status": {
        ...data["Clinical Trial Status"],
        "Drug Profile": data["Clinical Trial Status"]?.["Drug Profile"]?.map(
          (item, index) => {
            if (index === tableIndex) {
              if (shellKey === "Therapeutic Area") {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createRandomString(8),
                  },
                  "Therapeutic Area": {
                    ...item["Therapeutic Area"],
                    attributionId:
                      item["Therapeutic Area"]?.attributionId ||
                      createRandomString(8),
                    value:
                      item["Therapeutic Area"] &&
                      item["Therapeutic Area"]?.value.length > valueIndex
                        ? item["Therapeutic Area"].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item["Therapeutic Area"].value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [shellKey as DrugProfileShellKeysNotIncludeAttributionId]: {
                  ...item[
                    shellKey as DrugProfileShellKeysNotIncludeAttributionId
                  ],
                  attributionId:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.attributionId || createRandomString(8),
                  value:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ] &&
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.value.length > valueIndex
                      ? item[
                          shellKey as DrugProfileShellKeysNotIncludeAttributionId
                        ].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[
                            shellKey as DrugProfileShellKeysNotIncludeAttributionId
                          ].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }
            return item;
          },
        ),
      },
    }),

    "Clinical Trial Design-1": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) =>
      ({
        ...data,
        "Clinical Trial Status": {
          ...data["Clinical Trial Status"],
          "Clinical Trial Design-1": data["Clinical Trial Status"]?.[
            "Clinical Trial Design-1"
          ]?.map((item, index) => {
            if (index === tableIndex) {
              return {
                ...item,
                [shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention]:
                  {
                    ...item[
                      shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                    ],
                    attributionId:
                      item[
                        shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                      ]?.attributionId || createRandomString(8),
                    value:
                      item[
                        shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                      ] &&
                      item[
                        shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                      ]?.value.length > valueIndex
                        ? item[
                            shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                          ].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => valueItem !== null)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item[
                              shellKey as ClinicalTrialDesign1ShellKeysWithoutTrialIntervention
                            ].value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  if (valueText === "") {
                                    return null;
                                  }
                                  return { text: valueText, is_modified: true };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => valueItem !== null)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
              };
            }
            return item;
          }),
        },
      } as ArticleEntryData),
  },
  [SECTION_KEYS.companyWebsiteVariousPages]: {
    "Drug Profile": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      [SECTION_KEYS.companyWebsiteVariousPages]: {
        ...data[SECTION_KEYS.companyWebsiteVariousPages],
        "Drug Profile": data[SECTION_KEYS.companyWebsiteVariousPages]?.[
          "Drug Profile"
        ]?.map((item, index) => {
          if (index === tableIndex) {
            if (shellKey === "Therapeutic Area") {
              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                "Therapeutic Area": {
                  ...item["Therapeutic Area"],
                  attributionId:
                    item["Therapeutic Area"]?.attributionId ||
                    createRandomString(8),
                  value:
                    item["Therapeutic Area"] &&
                    item["Therapeutic Area"]?.value.length > valueIndex
                      ? item["Therapeutic Area"].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              const checkDictionaryList = dictionaryList
                                .map((listItem) => {
                                  const currentListItem =
                                    listItem.toLocaleLowerCase();
                                  const currentValueText =
                                    valueText.toLocaleLowerCase();

                                  if (currentListItem === currentValueText)
                                    return listItem;

                                  return null;
                                })
                                .filter(
                                  (listValueItem) => listValueItem !== null,
                                );

                              return {
                                text: checkDictionaryList[0] || "",
                                is_modified: true,
                              };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => !!valueItem.text)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );

                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item["Therapeutic Area"].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList =
                                  dictionaryList.filter((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    return currentListItem === currentValueText;
                                  });

                                return {
                                  text: checkDictionaryList[0],
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => !!valueItem.text)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text?.toLowerCase() ===
                                valueItem?.text?.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }

            return {
              ...item,
              attributionInfo: {
                attributionId:
                  item?.attributionInfo?.attributionId || createRandomString(8),
              },
              [shellKey as DrugProfileShellKeysNotIncludeAttributionId]: {
                ...item[
                  shellKey as DrugProfileShellKeysNotIncludeAttributionId
                ],
                attributionId:
                  item[shellKey as DrugProfileShellKeysNotIncludeAttributionId]
                    ?.attributionId || createRandomString(8),
                value:
                  item[
                    shellKey as DrugProfileShellKeysNotIncludeAttributionId
                  ] &&
                  item[shellKey as DrugProfileShellKeysNotIncludeAttributionId]
                    ?.value.length > valueIndex
                    ? item[
                        shellKey as DrugProfileShellKeysNotIncludeAttributionId
                      ].value
                        ?.map((valueItem, valueItemIndex) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        })
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...item[
                          shellKey as DrugProfileShellKeysNotIncludeAttributionId
                        ].value,
                        { text: valueText, is_modified: true },
                      ]
                        ?.map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            };
          }
          return item;
        }),
      },
    }),
  },
  Regulatory: {
    "Drug Profile": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      Regulatory: {
        ...data.Regulatory,
        "Drug Profile": data.Regulatory?.["Drug Profile"]?.map(
          (item, index) => {
            if (index === tableIndex) {
              if (shellKey === "Therapeutic Area") {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createRandomString(8),
                  },
                  "Therapeutic Area": {
                    ...item["Therapeutic Area"],
                    attributionId:
                      item["Therapeutic Area"]?.attributionId ||
                      createRandomString(8),
                    value:
                      item["Therapeutic Area"] &&
                      item["Therapeutic Area"]?.value.length > valueIndex
                        ? item["Therapeutic Area"].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item["Therapeutic Area"].value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [shellKey as RegulatoryDrugProfileShellKeysNotAttributionId]: {
                  ...item[
                    shellKey as RegulatoryDrugProfileShellKeysNotAttributionId
                  ],
                  attributionId:
                    item[
                      shellKey as RegulatoryDrugProfileShellKeysNotAttributionId
                    ]?.attributionId || createRandomString(8),
                  value:
                    item[
                      shellKey as RegulatoryDrugProfileShellKeysNotAttributionId
                    ] &&
                    item[
                      shellKey as RegulatoryDrugProfileShellKeysNotAttributionId
                    ]?.value.length > valueIndex
                      ? item[
                          shellKey as RegulatoryDrugProfileShellKeysNotAttributionId
                        ].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[
                            shellKey as RegulatoryDrugProfileShellKeysNotAttributionId
                          ].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }
            return item;
          },
        ),
      },
    }),
    "Approval Process Contents": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      if (shellKey === "Additional Information on the Approval Process")
        return {
          ...data,
          Regulatory: {
            ...data.Regulatory,
            "Approval Process Contents": {
              ...data.Regulatory?.["Approval Process Contents"],
              "Additional Information on the Approval Process": {
                ...data.Regulatory?.["Approval Process Contents"]?.[
                  "Additional Information on the Approval Process"
                ],
                value:
                  [
                    ...(data.Regulatory?.["Approval Process Contents"]?.[
                      "Additional Information on the Approval Process"
                    ]?.value || []),
                  ].length > valueIndex
                    ? data.Regulatory?.["Approval Process Contents"]?.[
                        "Additional Information on the Approval Process"
                      ]?.value
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (
                              valueItemIndex === valueIndex &&
                              shellKey ===
                                "Additional Information on the Approval Process"
                            ) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...(data.Regulatory?.["Approval Process Contents"]?.[
                          "Additional Information on the Approval Process"
                        ]?.value || []),
                        { text: valueText, is_modified: true },
                      ]
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (
                              valueItemIndex === valueIndex &&
                              shellKey ===
                                "Additional Information on the Approval Process"
                            ) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            },
          },
        } as ArticleEntryData;

      return {
        ...data,
        Regulatory: {
          ...data.Regulatory,
          "Approval Process Contents": {
            ...data.Regulatory?.["Approval Process Contents"],
            "Approval Process": data?.Regulatory?.[
              "Approval Process Contents"
            ]?.["Approval Process"]?.map(
              (groupShellInfo, groupShellInfoIndex) => {
                if (groupShellInfoIndex === groupShellIndex) {
                  const currentData =
                    groupShellInfo[shellKey as ApprovalProcessTypeShellKey];

                  return {
                    ...groupShellInfo,
                    [shellKey]: {
                      ...currentData,
                      value:
                        [...(currentData?.value || [])].length > valueIndex
                          ? currentData?.value
                              .map(
                                (
                                  valueItem: {
                                    text: string;
                                    is_modified: boolean;
                                  },
                                  valueItemIndex: number,
                                ) => {
                                  if (valueItemIndex === valueIndex) {
                                    if (valueText === "") {
                                      return null;
                                    }
                                    return {
                                      text: valueText,
                                      is_modified: true,
                                    };
                                  }
                                  return valueItem;
                                },
                              )
                              .filter((valueItem) => valueItem !== null)
                              .filter(
                                (valueItem, valueItemIndex, valueList) => {
                                  const lastValueIndex = valueList.findIndex(
                                    (target) =>
                                      target?.text.toLowerCase() ===
                                      valueItem?.text.toLowerCase(),
                                  );
                                  return valueItemIndex === lastValueIndex;
                                },
                              )
                          : [
                              ...(currentData?.value || []),
                              { text: valueText, is_modified: true },
                            ]
                              .map(
                                (
                                  valueItem: {
                                    text: string;
                                    is_modified: boolean;
                                  },
                                  valueItemIndex: number,
                                ) => {
                                  if (valueItemIndex === valueIndex) {
                                    if (valueText === "") {
                                      return null;
                                    }
                                    return {
                                      text: valueText,
                                      is_modified: true,
                                    };
                                  }
                                  return valueItem;
                                },
                              )
                              .filter((valueItem) => valueItem !== null)
                              .filter(
                                (valueItem, valueItemIndex, valueList) => {
                                  const lastValueIndex = valueList.findIndex(
                                    (target) =>
                                      target?.text.toLowerCase() ===
                                      valueItem?.text.toLowerCase(),
                                  );
                                  return valueItemIndex === lastValueIndex;
                                },
                              ),
                    },
                  };
                }
                return groupShellInfo;
              },
            ),
          },
        },
      } as ArticleEntryData;
    },

    "Key Comment": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        Regulatory: {
          ...data.Regulatory,
          "Key Comment": {
            ...data.Regulatory?.["Key Comment"],
            [shellKey]: {
              ...data.Regulatory?.["Key Comment"]?.[
                shellKey as ClinicalTrialsKeyCommentShellKey
              ],

              value:
                [
                  ...(data.Regulatory?.["Key Comment"]?.[
                    shellKey as QuoteAndSpokesPersonType
                  ].value || []),
                ].length > valueIndex
                  ? data.Regulatory?.["Key Comment"]?.[
                      shellKey as QuoteAndSpokesPersonType
                    ].value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                  : [
                      ...(data.Regulatory?.["Key Comment"]?.[
                        shellKey as QuoteAndSpokesPersonType
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null),
            },
          },
        },
      } as ArticleEntryData),
  },
  Deals: {
    "Drug Profile": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      Deals: {
        ...data.Deals,
        "Drug Profile": data.Deals?.["Drug Profile"]?.map((item, index) => {
          if (index === tableIndex) {
            if (shellKey === "Therapeutic Area") {
              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                "Therapeutic Area": {
                  ...item["Therapeutic Area"],
                  attributionId:
                    item["Therapeutic Area"]?.attributionId ||
                    createRandomString(8),
                  value:
                    item["Therapeutic Area"] &&
                    item["Therapeutic Area"]?.value.length > valueIndex
                      ? item["Therapeutic Area"].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              const checkDictionaryList = dictionaryList
                                .map((listItem) => {
                                  const currentListItem =
                                    listItem.toLocaleLowerCase();
                                  const currentValueText =
                                    valueText.toLocaleLowerCase();

                                  if (currentListItem === currentValueText)
                                    return listItem;

                                  return null;
                                })
                                .filter(
                                  (listValueItem) => listValueItem !== null,
                                );

                              return {
                                text: checkDictionaryList[0] || "",
                                is_modified: true,
                              };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => !!valueItem.text)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );

                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item["Therapeutic Area"].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList =
                                  dictionaryList.filter((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    return currentListItem === currentValueText;
                                  });

                                return {
                                  text: checkDictionaryList[0],
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => !!valueItem.text)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text?.toLowerCase() ===
                                valueItem?.text?.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }

            return {
              ...item,
              attributionInfo: {
                attributionId:
                  item?.attributionInfo?.attributionId || createRandomString(8),
              },
              [shellKey as DrugProfileShellKeysNotIncludeAttributionId]: {
                ...item[
                  shellKey as DrugProfileShellKeysNotIncludeAttributionId
                ],
                attributionId:
                  item[shellKey as DrugProfileShellKeysNotIncludeAttributionId]
                    ?.attributionId || createRandomString(8),
                value:
                  item[
                    shellKey as DrugProfileShellKeysNotIncludeAttributionId
                  ] &&
                  item[shellKey as DrugProfileShellKeysNotIncludeAttributionId]
                    ?.value.length > valueIndex
                    ? item[
                        shellKey as DrugProfileShellKeysNotIncludeAttributionId
                      ].value
                        ?.map((valueItem, valueItemIndex) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        })
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...item[
                          shellKey as DrugProfileShellKeysNotIncludeAttributionId
                        ].value,
                        { text: valueText, is_modified: true },
                      ]
                        ?.map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            };
          }
          return item;
        }),
      },
    }),
    "Deal Type & Status": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      if (shellKey === ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS.dealType) {
        const dealTypeAndStatusData =
          data?.[ENTRY_DATA_SECTION_KEYS.deals]?.[
            ENTRY_DATA_DEAL_TYPE_AND_STATUS
          ];

        const dealTypeShellData =
          data?.[ENTRY_DATA_SECTION_KEYS.deals]?.[
            ENTRY_DATA_DEAL_TYPE_AND_STATUS
          ]?.[ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS.dealType];

        return {
          ...data,
          [ENTRY_DATA_SECTION_KEYS.deals]: {
            ...data[ENTRY_DATA_SECTION_KEYS.deals],
            [ENTRY_DATA_DEAL_TYPE_AND_STATUS]: {
              ...dealTypeAndStatusData,
              [ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS.dealType]: {
                ...dealTypeShellData,
                value:
                  [...(dealTypeShellData?.value || [])].length > valueIndex
                    ? dealTypeShellData?.value
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText.toLocaleLowerCase(),
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...(dealTypeShellData?.value || []),
                        { text: valueText, is_modified: true },
                      ]
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText.toLocaleLowerCase(),
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            },
          },
        } as ArticleEntryData;
      }

      return {
        ...data,
        Deals: {
          ...data.Deals,
          "Deal Type & Status": {
            ...data.Deals?.["Deal Type & Status"],
            [shellKey]: {
              ...data.Deals?.["Deal Type & Status"]?.[
                shellKey as DealTypeAndStatusKey
              ],
              value:
                [
                  ...(data.Deals?.["Deal Type & Status"]?.[
                    shellKey as DealTypeAndStatusKey
                  ]?.value || []),
                ].length > valueIndex
                  ? data.Deals?.["Deal Type & Status"]?.[
                      shellKey as DealTypeAndStatusKey
                    ]?.value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(data.Deals?.["Deal Type & Status"]?.[
                        shellKey as DealTypeAndStatusKey
                      ]?.value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },

    "Licensee Table": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const advisorShellKeyList = [
        "Advisor Name",
        "Party Axis",
        "Advisor Role",
      ];

      if (
        tableKey === "Advisor Table" &&
        advisorShellKeyList.includes(shellKey)
      ) {
        return {
          ...data,
          [SECTION_KEYS.deals]: {
            ...data[SECTION_KEYS.deals],
            "Advisor Table": data[SECTION_KEYS.deals]?.["Advisor Table"]?.map(
              (tableItem, tableItemIndex) => {
                if (tableItemIndex === subGroupShellIndex) {
                  const currentValues =
                    tableItem?.[shellKey as DealLaScAdvisorShellKeys]?.value ||
                    [];
                  return {
                    ...tableItem,
                    [shellKey]: {
                      ...tableItem?.[shellKey as DealLaScAdvisorShellKeys],
                      options:
                        tableItem?.[shellKey as DealLaScAdvisorShellKeys]
                          ?.options || [],
                      value:
                        currentValues.length > valueIndex
                          ? currentValues
                              .map((valueItem, valueItemIndex) => {
                                if (valueItemIndex === valueIndex) {
                                  if (valueText === "") return null;
                                  return { text: valueText, is_modified: true };
                                }
                                return valueItem;
                              })
                              .filter((valueItem) => valueItem !== null)
                          : [
                              ...currentValues,
                              { text: valueText, is_modified: true },
                            ],
                    },
                  };
                }
                return tableItem;
              },
            ),
          },
        } as ArticleEntryData;
      }

      const licensorMAShellKeyList = [
        "Licensor Name(MA)",
        "Licensor Relationship Context(MA)",
        "Licensor Partial Acquisition Subject(MA)",
      ];

      if (
        tableKey === "Acquired Company" &&
        licensorMAShellKeyList.includes(shellKey)
      ) {
        const licensorMAExists =
          !!data[SECTION_KEYS.deals]?.["Licensor Table"]?.["Licensor(MA)"];

        if (!licensorMAExists) {
          if (shellKey === "Licensor Relationship Context(MA)") return data;
          // shellKey === "Licensor Name(MA)" → redirect to "Licensor Name"
          const currentLicensorNameData =
            data[SECTION_KEYS.deals]?.["Licensor Table"]?.["Licensor Name"];
          const currentValues = currentLicensorNameData?.value || [];
          const updatedValue =
            currentValues.length > valueIndex
              ? currentValues
                  .map((valueItem, valueItemIndex) => {
                    if (valueItemIndex === valueIndex) {
                      if (valueText === "") return null;
                      return { text: valueText, is_modified: true };
                    }
                    return valueItem;
                  })
                  .filter((valueItem) => valueItem !== null)
              : [...currentValues, { text: valueText, is_modified: true }];

          return {
            ...data,
            [SECTION_KEYS.deals]: {
              ...data[SECTION_KEYS.deals],
              "Licensor Table": {
                ...data[SECTION_KEYS.deals]?.["Licensor Table"],
                "Licensor Name": {
                  ...currentLicensorNameData,
                  value: updatedValue,
                },
              },
            },
          } as ArticleEntryData;
        }

        type LicensorMAKey =
          | "Licensor Name(MA)"
          | "Licensor Relationship Context(MA)"
          | "Licensor Partial Acquisition Subject(MA)";
        const updatedLicensorMA = data[SECTION_KEYS.deals]?.[
          "Licensor Table"
        ]?.["Licensor(MA)"]?.map((licensorItem, licensorItemIndex) => {
          if (licensorItemIndex === subGroupShellIndex) {
            const currentValues =
              licensorItem?.[shellKey as LicensorMAKey]?.value || [];
            return {
              ...licensorItem,
              [shellKey]: {
                ...licensorItem?.[shellKey as LicensorMAKey],
                options:
                  licensorItem?.[shellKey as LicensorMAKey]?.options || [],
                value:
                  currentValues.length > valueIndex
                    ? currentValues
                        .map((valueItem, valueItemIndex) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") return null;
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        })
                        .filter((valueItem) => valueItem !== null)
                    : [
                        ...currentValues,
                        { text: valueText, is_modified: true },
                      ],
              },
            };
          }
          return licensorItem;
        });

        const syncedLicensorName =
          shellKey === "Licensor Name(MA)"
            ? (updatedLicensorMA ?? []).flatMap(
                (item) => item?.["Licensor Name(MA)"]?.value ?? [],
              )
            : undefined;

        return {
          ...data,
          [SECTION_KEYS.deals]: {
            ...data[SECTION_KEYS.deals],
            "Licensor Table": {
              ...data[SECTION_KEYS.deals]?.["Licensor Table"],
              "Licensor(MA)": updatedLicensorMA,
              ...(syncedLicensorName !== undefined && {
                "Licensor Name": {
                  ...data[SECTION_KEYS.deals]?.["Licensor Table"]?.[
                    "Licensor Name"
                  ],
                  value: syncedLicensorName,
                },
              }),
            },
          },
        } as ArticleEntryData;
      }

      const licenseeMAShellKeyList = [
        "Licensee Name(MA)",
        "Licensee Relationship Context(MA)",
      ];

      if (
        tableKey === "Acquiring Company" &&
        licenseeMAShellKeyList.includes(shellKey)
      ) {
        const licenseeMAExists =
          !!data[SECTION_KEYS.deals]?.["Licensee Table"]?.[tableIndex]?.[
            "Licensee(MA)"
          ];

        if (!licenseeMAExists) {
          if (shellKey === "Licensee Relationship Context(MA)") return data;
          // shellKey === "Licensee Name(MA)" → redirect to "Licensee Name"
          return {
            ...data,
            [SECTION_KEYS.deals]: {
              ...data[SECTION_KEYS.deals],
              "Licensee Table": data[SECTION_KEYS.deals]?.[
                "Licensee Table"
              ]?.map((tableItem, tableItemIndex) => {
                if (tableItemIndex !== tableIndex) return tableItem;
                const currentLicenseeNameData =
                  tableItem[ENTRY_DATA_LICENSEE_TABLE_KEYS.licenseeName];
                const currentValues = currentLicenseeNameData?.value || [];
                const updatedValue =
                  currentValues.length > valueIndex
                    ? currentValues
                        .map((valueItem, valueItemIndex) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") return null;
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        })
                        .filter((valueItem) => valueItem !== null)
                    : [
                        ...currentValues,
                        { text: valueText, is_modified: true },
                      ];

                return {
                  ...tableItem,
                  [ENTRY_DATA_LICENSEE_TABLE_KEYS.licenseeName]: {
                    ...currentLicenseeNameData,
                    value: updatedValue,
                  },
                };
              }),
            },
          } as ArticleEntryData;
        }

        type LicenseeMAKey =
          | "Licensee Name(MA)"
          | "Licensee Relationship Context(MA)";

        return {
          ...data,
          [SECTION_KEYS.deals]: {
            ...data[SECTION_KEYS.deals],
            "Licensee Table": data[SECTION_KEYS.deals]?.["Licensee Table"]?.map(
              (tableItem, tableItemIndex) => {
                if (tableItemIndex === tableIndex) {
                  const updatedLicenseeMA = tableItem["Licensee(MA)"]?.map(
                    (licenseeItem, licenseeItemIndex) => {
                      if (licenseeItemIndex === subGroupShellIndex) {
                        const currentValues =
                          licenseeItem?.[shellKey as LicenseeMAKey]?.value ||
                          [];
                        return {
                          ...licenseeItem,
                          [shellKey]: {
                            ...licenseeItem?.[shellKey as LicenseeMAKey],
                            options:
                              licenseeItem?.[shellKey as LicenseeMAKey]
                                ?.options || [],
                            value:
                              currentValues.length > valueIndex
                                ? currentValues
                                    .map((valueItem, valueItemIndex) => {
                                      if (valueItemIndex === valueIndex) {
                                        if (valueText === "") return null;
                                        return {
                                          text: valueText,
                                          is_modified: true,
                                        };
                                      }
                                      return valueItem;
                                    })
                                    .filter((valueItem) => valueItem !== null)
                                : [
                                    ...currentValues,
                                    { text: valueText, is_modified: true },
                                  ],
                          },
                        };
                      }
                      return licenseeItem;
                    },
                  );

                  const syncedLicenseeName =
                    shellKey === "Licensee Name(MA)"
                      ? (updatedLicenseeMA ?? []).flatMap(
                          (item) => item?.["Licensee Name(MA)"]?.value ?? [],
                        )
                      : undefined;

                  return {
                    ...tableItem,
                    "Licensee(MA)": updatedLicenseeMA,
                    ...(syncedLicenseeName !== undefined && {
                      [ENTRY_DATA_LICENSEE_TABLE_KEYS.licenseeName]: {
                        ...tableItem[
                          ENTRY_DATA_LICENSEE_TABLE_KEYS.licenseeName
                        ],
                        value: syncedLicenseeName,
                      },
                    }),
                  };
                }
                return tableItem;
              },
            ),
          },
        } as ArticleEntryData;
      }

      const licensorShell =
        shellKey === "Licensor Name" ||
        shellKey === "Licensor Responsibility & Rights";

      const additionalInformationShell =
        shellKey === "Additional Information" ||
        shellKey === "Purpose of the Deal";

      if (licensorShell) {
        const currentLicensorData = data.Deals?.["Licensor Table"]?.[shellKey];

        const updatedLicensorValue =
          [...(currentLicensorData?.value || [])].length > valueIndex
            ? currentLicensorData?.value
                .map(
                  (
                    valueItem: { text: string; is_modified: boolean },
                    valueItemIndex: number,
                  ) => {
                    if (valueItemIndex === valueIndex) {
                      if (valueText === "") return null;
                      return { text: valueText, is_modified: true };
                    }
                    return valueItem;
                  },
                )
                .filter((valueItem) => valueItem !== null)
                .filter((valueItem, valueItemIndex, valueList) => {
                  const lastValueIndex = valueList.findIndex(
                    (target) =>
                      target?.text.toLowerCase() ===
                      valueItem?.text.toLowerCase(),
                  );
                  return valueItemIndex === lastValueIndex;
                })
            : [
                ...(currentLicensorData?.value || []),
                { text: valueText, is_modified: true },
              ]
                .map(
                  (
                    valueItem: { text: string; is_modified: boolean },
                    valueItemIndex: number,
                  ) => {
                    if (valueItemIndex === valueIndex) {
                      if (valueText === "") return null;
                      return { text: valueText, is_modified: true };
                    }
                    return valueItem;
                  },
                )
                .filter((valueItem) => valueItem !== null)
                .filter((valueItem, valueItemIndex, valueList) => {
                  const lastValueIndex = valueList.findIndex(
                    (target) =>
                      target?.text.toLowerCase() ===
                      valueItem?.text.toLowerCase(),
                  );
                  return valueItemIndex === lastValueIndex;
                });

        const existingLicensorMA =
          data.Deals?.["Licensor Table"]?.["Licensor(MA)"];
        const syncedLicensorMA =
          shellKey === "Licensor Name" && existingLicensorMA?.length
            ? existingLicensorMA.map((item: any, idx: number) => ({
                ...item,
                "Licensor Name(MA)": {
                  ...item["Licensor Name(MA)"],
                  value:
                    updatedLicensorValue?.[idx] !== undefined
                      ? [updatedLicensorValue[idx]]
                      : [],
                },
              }))
            : existingLicensorMA;

        return {
          ...data,
          Deals: {
            ...data.Deals,
            "Licensor Table": {
              ...data.Deals?.["Licensor Table"],
              [shellKey]: {
                ...currentLicensorData,
                value: updatedLicensorValue,
              },
              ...(syncedLicensorMA !== undefined && {
                "Licensor(MA)": syncedLicensorMA,
              }),
            },
          },
        } as ArticleEntryData;
      }

      if (additionalInformationShell) {
        return {
          ...data,
          Deals: {
            ...data.Deals,
            "Additional Information (Deal)": {
              ...data.Deals?.["Additional Information (Deal)"],
              [shellKey]: {
                ...data.Deals?.["Additional Information (Deal)"]?.[shellKey],
                value:
                  [
                    ...(data.Deals?.["Additional Information (Deal)"]?.[
                      shellKey
                    ]?.value || []),
                  ].length > valueIndex
                    ? data.Deals?.["Additional Information (Deal)"]?.[
                        shellKey
                      ]?.value
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText,
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...(data.Deals?.["Additional Information (Deal)"]?.[
                          shellKey
                        ]?.value || []),
                        { text: valueText, is_modified: true },
                      ]
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText,
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            },
          },
        } as ArticleEntryData;
      }

      const dealStructureShellKeyList = [
        "Mechanical Structure",
        "Structural Tags",
        "Structural Notes",
      ];

      if (
        tableKey === "Deal Structure" &&
        dealStructureShellKeyList.includes(shellKey)
      ) {
        type DealStructureShellKey =
          | "Mechanical Structure"
          | "Structural Tags"
          | "Structural Notes";
        const currentShellData =
          data.Deals?.["Deal Structure"]?.[shellKey as DealStructureShellKey];
        return {
          ...data,
          Deals: {
            ...data.Deals,
            "Deal Structure": {
              ...data.Deals?.["Deal Structure"],
              [shellKey]: {
                ...currentShellData,
                value:
                  [...(currentShellData?.value || [])].length > valueIndex
                    ? currentShellData?.value
                        .map(
                          (
                            valueItem: { text: string; is_modified: boolean },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") return null;
                              return { text: valueText, is_modified: true };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...(currentShellData?.value || []),
                        { text: valueText, is_modified: true },
                      ]
                        .map(
                          (
                            valueItem: { text: string; is_modified: boolean },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") return null;
                              return { text: valueText, is_modified: true };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            },
          },
        } as ArticleEntryData;
      }

      return {
        ...data,
        Deals: {
          ...data.Deals,
          "Licensee Table": data.Deals?.["Licensee Table"]?.map(
            (tableInfo, tableInfoIndex) => {
              if (tableInfoIndex === tableIndex) {
                const scAndLcShell =
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.upfrontPayment ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.totalPaymentScLa ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.royalty ||
                  shellKey ===
                    ENTRY_DATA_MILESTONE_PAYMENT_CONDITION_KEYS.milestonePayment ||
                  shellKey ===
                    ENTRY_DATA_MILESTONE_PAYMENT_CONDITION_KEYS.milestoneConditionTitle ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.otherFinancialTermsScLa ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.licenseeResponsibilityAndRightsScLa ||
                  shellKey ===
                    ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentScLa ||
                  shellKey ===
                    ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentDetailScLa ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.disclosedPaymentsSumScLa;

                const isRightsScopeShell =
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.drug ||
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.indication ||
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.exclusivity ||
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.territory ||
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.assetContributor;

                const isMergeAcquisitionShell =
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.licenseeResponsibilityAndRightsMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.numberOfAcquiringShares ||
                  shellKey === MERGE_ACQUISITION_SHELL_KEYS.pricePerShare ||
                  shellKey === MERGE_ACQUISITION_SHELL_KEYS.totalPaymentMa ||
                  shellKey === MERGE_ACQUISITION_SHELL_KEYS.upfrontPaymentMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.upfrontPricePerShareMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.contingentPaymentMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.contingentPricePerShareMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.contingentMilestoneMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.mergerFinancialTermsMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.otherFinancialTermsMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.disclosedPaymentsSumMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.disclosedPaymentsSumPricePerShareMa;

                const isVentureFormationShell =
                  shellKey === VENTURE_FORMATION_SHELL_KEYS.initialInvestment ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.contingentInvestment ||
                  shellKey === VENTURE_FORMATION_SHELL_KEYS.contingentDetail ||
                  shellKey === VENTURE_FORMATION_SHELL_KEYS.totalInvestmentVf ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.disclosedPaymentsSumVf ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.ownershipStructureDetails ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.otherFinancialTermsVf ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.licenseeResponsibilityAndRightsVf;

                if (shellKey === "Licensee Name") {
                  const currentLicenseeName = tableInfo?.["Licensee Name"];

                  const updatedLicenseeNameValue =
                    [...(currentLicenseeName?.value || [])].length > valueIndex
                      ? currentLicenseeName?.value
                          .map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return {
                                  text: valueText,
                                  is_modified: true,
                                };
                              }
                              return valueItem;
                            },
                          )
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...(currentLicenseeName?.value || []),
                          { text: valueText, is_modified: true },
                        ]
                          .map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return {
                                  text: valueText,
                                  is_modified: true,
                                };
                              }
                              return valueItem;
                            },
                          )
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          });

                  const existingLicenseeMA = (tableInfo as any)?.[
                    "Licensee(MA)"
                  ];
                  const syncedLicenseeMA = existingLicenseeMA?.length
                    ? existingLicenseeMA.map((item: any, idx: number) => ({
                        ...item,
                        "Licensee Name(MA)": {
                          ...item["Licensee Name(MA)"],
                          value:
                            updatedLicenseeNameValue[idx] !== undefined
                              ? [updatedLicenseeNameValue[idx]]
                              : [],
                        },
                      }))
                    : existingLicenseeMA;

                  return {
                    ...tableInfo,
                    [shellKey]: {
                      ...currentLicenseeName,
                      value: updatedLicenseeNameValue,
                    },
                    ...(syncedLicenseeMA !== undefined && {
                      "Licensee(MA)": syncedLicenseeMA,
                    }),
                  };
                }

                if (isRightsScopeShell) {
                  return {
                    ...tableInfo,
                    "Rights Scope": tableInfo["Rights Scope"]?.map(
                      (groupShellInfo, groupShellInfoIndex) => {
                        if (groupShellInfoIndex === groupShellIndex) {
                          const currentRightsScopeShell =
                            groupShellInfo?.[shellKey];

                          return {
                            ...groupShellInfo,
                            [shellKey]: {
                              ...currentRightsScopeShell,
                              value:
                                [...(currentRightsScopeShell?.value || [])]
                                  .length > valueIndex
                                  ? currentRightsScopeShell?.value
                                      .map(
                                        (
                                          valueItem: {
                                            text: string;
                                            is_modified: boolean;
                                          },
                                          valueItemIndex: number,
                                        ) => {
                                          if (valueItemIndex === valueIndex) {
                                            if (valueText === "") {
                                              return null;
                                            }
                                            return {
                                              text: valueText,
                                              is_modified: true,
                                            };
                                          }
                                          return valueItem;
                                        },
                                      )
                                      .filter((valueItem) => valueItem !== null)
                                      .filter(
                                        (
                                          valueItem,
                                          valueItemIndex,
                                          valueList,
                                        ) => {
                                          const lastValueIndex =
                                            valueList.findIndex(
                                              (target) =>
                                                target?.text.toLowerCase() ===
                                                valueItem?.text.toLowerCase(),
                                            );
                                          return (
                                            valueItemIndex === lastValueIndex
                                          );
                                        },
                                      )
                                  : [
                                      ...(currentRightsScopeShell?.value || []),
                                      { text: valueText, is_modified: true },
                                    ]
                                      .map(
                                        (
                                          valueItem: {
                                            text: string;
                                            is_modified: boolean;
                                          },
                                          valueItemIndex: number,
                                        ) => {
                                          if (valueItemIndex === valueIndex) {
                                            if (valueText === "") {
                                              return null;
                                            }
                                            return {
                                              text: valueText,
                                              is_modified: true,
                                            };
                                          }
                                          return valueItem;
                                        },
                                      )
                                      .filter((valueItem) => valueItem !== null)
                                      .filter(
                                        (
                                          valueItem,
                                          valueItemIndex,
                                          valueList,
                                        ) => {
                                          const lastValueIndex =
                                            valueList.findIndex(
                                              (target) =>
                                                target?.text.toLowerCase() ===
                                                valueItem?.text.toLowerCase(),
                                            );
                                          return (
                                            valueItemIndex === lastValueIndex
                                          );
                                        },
                                      ),
                            },
                          };
                        }

                        return groupShellInfo;
                      },
                    ),
                  };
                }

                if (isMergeAcquisitionShell) {
                  const currentMerge =
                    tableInfo?.[
                      ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms
                    ];

                  const isContingentPaymentShellKeyList =
                    shellKey ===
                      MERGE_ACQUISITION_SHELL_KEYS.contingentPaymentMa ||
                    shellKey ===
                      MERGE_ACQUISITION_SHELL_KEYS.contingentPricePerShareMa ||
                    shellKey ===
                      MERGE_ACQUISITION_SHELL_KEYS.contingentMilestoneMa;

                  if (isContingentPaymentShellKeyList)
                    return {
                      ...tableInfo,
                      [ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms]: {
                        ...currentMerge,
                        [ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS.contingentPayment]:
                          tableInfo[
                            ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms
                          ][
                            ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS
                              .contingentPayment
                          ]?.map(
                            (subGroupShellInfo, subGroupShellInfoIndex) => {
                              if (
                                subGroupShellInfoIndex === subGroupShellIndex
                              ) {
                                const currentContingentPaymentShell =
                                  subGroupShellInfo?.[shellKey];

                                return {
                                  ...subGroupShellInfo,
                                  [shellKey]: {
                                    ...currentContingentPaymentShell,
                                    value:
                                      [
                                        ...(currentContingentPaymentShell?.value ||
                                          []),
                                      ].length > valueIndex
                                        ? currentContingentPaymentShell?.value
                                            .map(
                                              (
                                                valueItem: {
                                                  text: string;
                                                  is_modified: boolean;
                                                },
                                                valueItemIndex: number,
                                              ) => {
                                                if (
                                                  valueItemIndex === valueIndex
                                                ) {
                                                  if (valueText === "") {
                                                    return null;
                                                  }
                                                  return {
                                                    text: valueText,
                                                    is_modified: true,
                                                  };
                                                }
                                                return valueItem;
                                              },
                                            )
                                            .filter(
                                              (valueItem) => valueItem !== null,
                                            )
                                            .filter(
                                              (
                                                valueItem,
                                                valueItemIndex,
                                                valueList,
                                              ) => {
                                                const lastValueIndex =
                                                  valueList.findIndex(
                                                    (target) =>
                                                      target?.text.toLowerCase() ===
                                                      valueItem?.text.toLowerCase(),
                                                  );
                                                return (
                                                  valueItemIndex ===
                                                  lastValueIndex
                                                );
                                              },
                                            )
                                        : [
                                            ...(currentContingentPaymentShell?.value ||
                                              []),
                                            {
                                              text: valueText,
                                              is_modified: true,
                                            },
                                          ]
                                            .map(
                                              (
                                                valueItem: {
                                                  text: string;
                                                  is_modified: boolean;
                                                },
                                                valueItemIndex: number,
                                              ) => {
                                                if (
                                                  valueItemIndex === valueIndex
                                                ) {
                                                  if (valueText === "") {
                                                    return null;
                                                  }
                                                  return {
                                                    text: valueText,
                                                    is_modified: true,
                                                  };
                                                }
                                                return valueItem;
                                              },
                                            )
                                            .filter(
                                              (valueItem) => valueItem !== null,
                                            )
                                            .filter(
                                              (
                                                valueItem,
                                                valueItemIndex,
                                                valueList,
                                              ) => {
                                                const lastValueIndex =
                                                  valueList.findIndex(
                                                    (target) =>
                                                      target?.text.toLowerCase() ===
                                                      valueItem?.text.toLowerCase(),
                                                  );
                                                return (
                                                  valueItemIndex ===
                                                  lastValueIndex
                                                );
                                              },
                                            ),
                                  },
                                };
                              }

                              return subGroupShellInfo;
                            },
                          ),
                      },
                    };

                  return {
                    ...tableInfo,
                    [ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms]: {
                      ...currentMerge,
                      [shellKey]: {
                        ...currentMerge?.[shellKey],
                        value:
                          [...(currentMerge?.[shellKey]?.value || [])].length >
                          valueIndex
                            ? currentMerge?.[shellKey]?.value
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                )
                            : [
                                ...(currentMerge?.[shellKey]?.value || []),
                                { text: valueText, is_modified: true },
                              ]
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                ),
                      },
                    },
                  };
                }

                if (isVentureFormationShell) {
                  const currentVentureFormation =
                    tableInfo?.[
                      ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms
                    ];

                  const isContingentPaymentShellKeyList =
                    shellKey ===
                      VENTURE_FORMATION_SHELL_KEYS.contingentInvestment ||
                    shellKey === VENTURE_FORMATION_SHELL_KEYS.contingentDetail;

                  if (isContingentPaymentShellKeyList)
                    return {
                      ...tableInfo,
                      [ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms]: {
                        ...currentVentureFormation,
                        [ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentInvestmentAndDetailVf]:
                          tableInfo[
                            ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms
                          ][
                            ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS
                              .contingentInvestmentAndDetailVf
                          ]?.map(
                            (subGroupShellInfo, subGroupShellInfoIndex) => {
                              if (
                                subGroupShellInfoIndex === subGroupShellIndex
                              ) {
                                const currentShell =
                                  subGroupShellInfo?.[shellKey];

                                return {
                                  ...subGroupShellInfo,
                                  [shellKey]: {
                                    ...currentShell,
                                    value:
                                      [...(currentShell?.value || [])].length >
                                      valueIndex
                                        ? currentShell?.value
                                            .map(
                                              (
                                                valueItem: {
                                                  text: string;
                                                  is_modified: boolean;
                                                },
                                                valueItemIndex: number,
                                              ) => {
                                                if (
                                                  valueItemIndex === valueIndex
                                                ) {
                                                  if (valueText === "") {
                                                    return null;
                                                  }
                                                  return {
                                                    text: valueText,
                                                    is_modified: true,
                                                  };
                                                }
                                                return valueItem;
                                              },
                                            )
                                            .filter(
                                              (valueItem) => valueItem !== null,
                                            )
                                            .filter(
                                              (
                                                valueItem,
                                                valueItemIndex,
                                                valueList,
                                              ) => {
                                                const lastValueIndex =
                                                  valueList.findIndex(
                                                    (target) =>
                                                      target?.text.toLowerCase() ===
                                                      valueItem?.text.toLowerCase(),
                                                  );
                                                return (
                                                  valueItemIndex ===
                                                  lastValueIndex
                                                );
                                              },
                                            )
                                        : [
                                            ...(currentShell?.value || []),
                                            {
                                              text: valueText,
                                              is_modified: true,
                                            },
                                          ]
                                            .map(
                                              (
                                                valueItem: {
                                                  text: string;
                                                  is_modified: boolean;
                                                },
                                                valueItemIndex: number,
                                              ) => {
                                                if (
                                                  valueItemIndex === valueIndex
                                                ) {
                                                  if (valueText === "") {
                                                    return null;
                                                  }
                                                  return {
                                                    text: valueText,
                                                    is_modified: true,
                                                  };
                                                }
                                                return valueItem;
                                              },
                                            )
                                            .filter(
                                              (valueItem) => valueItem !== null,
                                            )
                                            .filter(
                                              (
                                                valueItem,
                                                valueItemIndex,
                                                valueList,
                                              ) => {
                                                const lastValueIndex =
                                                  valueList.findIndex(
                                                    (target) =>
                                                      target?.text.toLowerCase() ===
                                                      valueItem?.text.toLowerCase(),
                                                  );
                                                return (
                                                  valueItemIndex ===
                                                  lastValueIndex
                                                );
                                              },
                                            ),
                                  },
                                };
                              }

                              return subGroupShellInfo;
                            },
                          ),
                      },
                    };

                  return {
                    ...tableInfo,
                    [ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms]: {
                      ...currentVentureFormation,
                      [shellKey]: {
                        ...currentVentureFormation?.[shellKey],
                        value:
                          [
                            ...(currentVentureFormation?.[shellKey]?.value ||
                              []),
                          ].length > valueIndex
                            ? currentVentureFormation?.[shellKey]?.value
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                )
                            : [
                                ...(currentVentureFormation?.[shellKey]
                                  ?.value || []),
                                { text: valueText, is_modified: true },
                              ]
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                ),
                      },
                    },
                  };
                }

                if (scAndLcShell) {
                  const currentScAndLa =
                    tableInfo[
                      "Strategic Collaboration & License Agreement terms"
                    ];

                  const isMilestoneShell =
                    shellKey ===
                      ENTRY_DATA_MILESTONE_PAYMENT_CONDITION_KEYS.milestonePayment ||
                    shellKey ===
                      ENTRY_DATA_MILESTONE_PAYMENT_CONDITION_KEYS.milestoneConditionTitle;

                  const isOtherPaymentAndDetailShell =
                    shellKey ===
                      ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentScLa ||
                    shellKey ===
                      ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentDetailScLa;

                  // NOTE : 대문자로 변경

                  if (isMilestoneShell) {
                    return {
                      ...tableInfo,
                      "Strategic Collaboration & License Agreement terms": {
                        ...currentScAndLa,
                        "Milestone Payment and Condition": currentScAndLa[
                          "Milestone Payment and Condition"
                        ]?.map((subGroupShellInfo, subGroupShellInfoIndex) => {
                          if (subGroupShellInfoIndex === subGroupShellIndex) {
                            const currentMilestone =
                              subGroupShellInfo?.[shellKey];

                            return {
                              ...subGroupShellInfo,
                              [shellKey]: {
                                ...currentMilestone,
                                value:
                                  valueText !== ""
                                    ? [
                                        {
                                          text: valueText,
                                          is_modified: true,
                                        },
                                      ]
                                    : [],
                              },
                            };
                          }
                          return subGroupShellInfo;
                        }),
                      },
                    };
                  }

                  if (isOtherPaymentAndDetailShell) {
                    return {
                      ...tableInfo,
                      [ENTRY_DATA_LICENSEE_TABLE_KEYS.strategicCollaborationLicenseAgreementTerms]:
                        {
                          ...currentScAndLa,
                          [ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.otherPaymentAndDetailScLa]:
                            currentScAndLa[
                              ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS
                                .otherPaymentAndDetailScLa
                            ]?.map(
                              (subGroupShellInfo, subGroupShellInfoIndex) => {
                                if (
                                  subGroupShellInfoIndex === subGroupShellIndex
                                ) {
                                  const currentOtherPaymentShell =
                                    subGroupShellInfo?.[shellKey];

                                  return {
                                    ...subGroupShellInfo,
                                    [shellKey]: {
                                      ...currentOtherPaymentShell,
                                      value:
                                        valueText !== ""
                                          ? [
                                              {
                                                text: valueText,
                                                is_modified: true,
                                              },
                                            ]
                                          : [],
                                    },
                                  };
                                }
                                return subGroupShellInfo;
                              },
                            ),
                        },
                    };
                  }

                  return {
                    ...tableInfo,
                    "Strategic Collaboration & License Agreement terms": {
                      ...currentScAndLa,
                      [shellKey]: {
                        ...currentScAndLa?.[shellKey],
                        value:
                          [...(currentScAndLa?.[shellKey]?.value || [])]
                            .length > valueIndex
                            ? currentScAndLa?.[shellKey]?.value
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                )
                            : [
                                ...(currentScAndLa?.[shellKey]?.value || []),
                                { text: valueText, is_modified: true },
                              ]
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                ),
                      },
                    },
                  };
                }
              }

              return tableInfo;
            },
          ),
        },
      } as ArticleEntryData;
    },
    "Advisor Table": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const advisorShellKeyList = [
        "Advisor Name",
        "Advisor Role",
        "Party Axis",
      ];

      if (advisorShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.deals]: {
            ...data[SECTION_KEYS.deals],
            "Advisor Table": data[SECTION_KEYS.deals]?.["Advisor Table"]?.map(
              (tableItem, tableItemIndex) => {
                if (tableItemIndex === subGroupShellIndex) {
                  return {
                    ...tableItem,
                    [shellKey]: {
                      ...tableItem?.[shellKey as DealsAdvisorShellKeys],
                      options:
                        tableItem?.[shellKey as DealsAdvisorShellKeys]
                          ?.options || [],
                      value: (() => {
                        const currentValues =
                          tableItem?.[shellKey as DealsAdvisorShellKeys]
                            ?.value || [];

                        if (currentValues.length > valueIndex) {
                          return currentValues
                            .map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }
                              return valueItem;
                            })
                            .filter((valueItem) => valueItem !== null);
                        }

                        return [
                          ...currentValues,
                          { text: valueText, is_modified: true },
                        ];
                      })(),
                    },
                  };
                }
                return tableItem;
              },
            ),
          },
        };
      }
      return data;
    },
    "Key Comment": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentKeyComment = data.Deals?.["Key Comment"];
      const currentValues =
        currentKeyComment?.[shellKey as QuoteAndSpokesPersonType]?.value || [];

      const newValues =
        currentValues.length > valueIndex
          ? currentValues
              .map(
                (
                  valueItem: { text: string; is_modified: boolean },
                  valueItemIndex: number,
                ) => {
                  if (valueItemIndex === valueIndex) {
                    if (valueText === "") return null;
                    return { text: valueText, is_modified: true };
                  }
                  return valueItem;
                },
              )
              .filter((valueItem) => valueItem !== null)
          : [...currentValues, { text: valueText, is_modified: true }]
              .map(
                (
                  valueItem: { text: string; is_modified: boolean },
                  valueItemIndex: number,
                ) => {
                  if (valueItemIndex === valueIndex) {
                    if (valueText === "") return null;
                    return { text: valueText, is_modified: true };
                  }
                  return valueItem;
                },
              )
              .filter((valueItem) => valueItem !== null);

      type CommentShellKey = "Comment Quote" | "Comment Spokesperson";
      const syncShellKey: CommentShellKey =
        shellKey === "Quote" ? "Comment Quote" : "Comment Spokesperson";
      const currentList = data.Deals?.["Key Comment List"] || [];
      const firstItem = currentList[0] ?? {
        "Comment Quote": { value: [], options: [] },
        "Comment Spokesperson": { value: [], options: [] },
      };
      const syncedFirstItem = {
        ...firstItem,
        [syncShellKey]: {
          ...firstItem[syncShellKey],
          value: newValues,
        },
      };
      const newList =
        currentList.length > 0
          ? currentList.map((item, idx) => (idx === 0 ? syncedFirstItem : item))
          : [syncedFirstItem];

      return {
        ...data,
        Deals: {
          ...data.Deals,
          "Key Comment": {
            ...currentKeyComment,
            [shellKey]: {
              ...currentKeyComment?.[
                shellKey as ClinicalTrialsKeyCommentShellKey
              ],
              value: newValues,
            },
          },
          "Key Comment List": newList,
        },
      } as ArticleEntryData;
    },
    "Key Comment List": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      type CommentShellKey = "Comment Quote" | "Comment Spokesperson";
      const targetIndex = subGroupShellIndex ?? 0;
      const currentList = data.Deals?.["Key Comment List"] || [];
      const currentItem = currentList[targetIndex] || {
        "Comment Quote": { value: [], options: [] },
        "Comment Spokesperson": { value: [], options: [] },
      };
      const currentShellData = currentItem[shellKey as CommentShellKey];
      const currentValues = currentShellData?.value || [];

      const newValues =
        currentValues.length > valueIndex
          ? currentValues
              .map(
                (
                  valueItem: { text: string; is_modified: boolean },
                  valueItemIndex: number,
                ) => {
                  if (valueItemIndex === valueIndex) {
                    if (valueText === "") return null;
                    return { text: valueText, is_modified: true };
                  }
                  return valueItem;
                },
              )
              .filter((valueItem) => valueItem !== null)
          : [...currentValues, { text: valueText, is_modified: true }]
              .map(
                (
                  valueItem: { text: string; is_modified: boolean },
                  valueItemIndex: number,
                ) => {
                  if (valueItemIndex === valueIndex) {
                    if (valueText === "") return null;
                    return { text: valueText, is_modified: true };
                  }
                  return valueItem;
                },
              )
              .filter((valueItem) => valueItem !== null);

      const newList = currentList.map((item, idx) =>
        idx === targetIndex
          ? {
              ...item,
              [shellKey]: { ...currentShellData, value: newValues },
            }
          : item,
      );

      if (currentList.length <= targetIndex) {
        newList.push({
          ...currentItem,
          [shellKey]: { ...currentShellData, value: newValues },
        });
      }

      type KeyCommentShellKey = "Quote" | "Spokesperson";
      const syncShellKey: KeyCommentShellKey =
        shellKey === "Comment Quote" ? "Quote" : "Spokesperson";
      const syncedKeyComment =
        targetIndex === 0
          ? {
              ...data.Deals?.["Key Comment"],
              [syncShellKey]: {
                ...data.Deals?.["Key Comment"]?.[
                  syncShellKey as ClinicalTrialsKeyCommentShellKey
                ],
                value: newValues,
              },
            }
          : data.Deals?.["Key Comment"];

      return {
        ...data,
        Deals: {
          ...data.Deals,
          "Key Comment": syncedKeyComment,
          "Key Comment List": newList,
        },
      } as ArticleEntryData;
    },
  },
  [SECTION_KEYS.dealsLaSc]: {
    "Drug Profile": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      [SECTION_KEYS.dealsLaSc]: {
        ...data[SECTION_KEYS.dealsLaSc],
        "Drug Profile": data[SECTION_KEYS.dealsLaSc]?.["Drug Profile"]?.map(
          (item, index) => {
            if (index === tableIndex) {
              if (shellKey === "Therapeutic Area") {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createRandomString(8),
                  },
                  "Therapeutic Area": {
                    ...item["Therapeutic Area"],
                    attributionId:
                      item["Therapeutic Area"]?.attributionId ||
                      createRandomString(8),
                    value:
                      item["Therapeutic Area"] &&
                      item["Therapeutic Area"]?.value.length > valueIndex
                        ? item["Therapeutic Area"].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item["Therapeutic Area"].value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [shellKey as DrugProfileShellKeysNotIncludeAttributionId]: {
                  ...item[
                    shellKey as DrugProfileShellKeysNotIncludeAttributionId
                  ],
                  attributionId:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.attributionId || createRandomString(8),
                  value:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ] &&
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.value.length > valueIndex
                      ? item[
                          shellKey as DrugProfileShellKeysNotIncludeAttributionId
                        ].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[
                            shellKey as DrugProfileShellKeysNotIncludeAttributionId
                          ].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }
            return item;
          },
        ),
      },
    }),
    "Deal Terms & Additional Information": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const singleShellKeyList = [
        "Deal Purpose",
        "Additional Information",
        "Other Financial Terms",
      ];

      const partnerAxisShellKeyList = [
        "Partner A Responsibility & Rights",
        "Partner B Responsibility & Rights",
        "Partner C Responsibility & Rights",
      ];

      const partnerAShellKeyList = [
        "Partner A Name",
        "Partner A Relationship Context",
      ];

      const partnerBShellKeyList = [
        "Partner B Name",
        "Partner B Relationship Context",
      ];

      const partnerCShellKeyList = [
        "Partner C Name",
        "Partner C Relationship Context",
      ];

      if (singleShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            [shellKey]: {
              ...data[SECTION_KEYS.dealsLaSc]?.[
                shellKey as DealLaScDealTermsSingleTableShellKeys
              ],
              options:
                data[SECTION_KEYS.dealsLaSc]?.[
                  shellKey as DealLaScDealTermsSingleTableShellKeys
                ]?.options || [],
              value:
                [
                  ...(data[SECTION_KEYS.dealsLaSc]?.[
                    shellKey as DealLaScDealTermsSingleTableShellKeys
                  ]?.value || []),
                ].length > valueIndex
                  ? data[SECTION_KEYS.dealsLaSc]?.[
                      shellKey as DealLaScDealTermsSingleTableShellKeys
                    ]?.value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(data[SECTION_KEYS.dealsLaSc]?.[
                        shellKey as DealLaScDealTermsSingleTableShellKeys
                      ]?.value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        };
      }
      if (partnerAxisShellKeyList.includes(shellKey)) {
        const currentPartnerAxis =
          data[SECTION_KEYS.dealsLaSc]?.["Partner Axis"];
        const emptyValueAndOptions = { value: [], options: [] };

        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Partner Axis": {
              ...data?.[SECTION_KEYS.dealsLaSc]?.["Partner Axis"],
              "Partner A Responsibility & Rights":
                currentPartnerAxis?.["Partner A Responsibility & Rights"] ||
                emptyValueAndOptions,
              "Partner B Responsibility & Rights":
                currentPartnerAxis?.["Partner B Responsibility & Rights"] ||
                emptyValueAndOptions,
              "Partner C Responsibility & Rights":
                currentPartnerAxis?.["Partner C Responsibility & Rights"] ||
                emptyValueAndOptions,
              [shellKey]: {
                ...currentPartnerAxis?.[
                  shellKey as DealLaScDealTermsPartnerAxisTableShellKeys
                ],
                options:
                  currentPartnerAxis?.[
                    shellKey as DealLaScDealTermsPartnerAxisTableShellKeys
                  ]?.options || [],
                value:
                  [
                    ...(currentPartnerAxis?.[
                      shellKey as DealLaScDealTermsPartnerAxisTableShellKeys
                    ]?.value || []),
                  ].length > valueIndex
                    ? currentPartnerAxis?.[
                        shellKey as DealLaScDealTermsPartnerAxisTableShellKeys
                      ]?.value
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText,
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...(currentPartnerAxis?.[
                          shellKey as DealLaScDealTermsPartnerAxisTableShellKeys
                        ]?.value || []),
                        { text: valueText, is_modified: true },
                      ]
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText,
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            },
          },
        };
      }
      if (partnerAShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Partner Axis": {
              ...data[SECTION_KEYS.dealsLaSc]?.["Partner Axis"],
              "Partner A": data[SECTION_KEYS.dealsLaSc]?.["Partner Axis"]?.[
                "Partner A"
              ].map((subGroupShellItem, subGroupShellItemIndex) => {
                if (subGroupShellItemIndex === subGroupShellIndex) {
                  return {
                    ...subGroupShellItem,
                    [shellKey]: {
                      ...subGroupShellItem?.[
                        shellKey as DealLaScPartnerAShellKeys
                      ],
                      options:
                        subGroupShellItem?.[
                          shellKey as DealLaScPartnerAShellKeys
                        ]?.options || [],
                      value: (() => {
                        const currentValues =
                          subGroupShellItem?.[
                            shellKey as DealLaScPartnerAShellKeys
                          ]?.value || [];

                        if (currentValues.length > valueIndex) {
                          return currentValues
                            .map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return {
                                  text: valueText,
                                  is_modified: true,
                                };
                              }
                              return valueItem;
                            })
                            .filter((valueItem) => valueItem !== null);
                        }

                        return [
                          ...currentValues,
                          { text: valueText, is_modified: true },
                        ];
                      })(),
                    },
                  };
                }
                return subGroupShellItem;
              }),
            },
          },
        };
      }
      if (partnerBShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Partner Axis": {
              ...data[SECTION_KEYS.dealsLaSc]?.["Partner Axis"],
              "Partner B": data[SECTION_KEYS.dealsLaSc]?.["Partner Axis"]?.[
                "Partner B"
              ].map((subGroupShellItem, subGroupShellItemIndex) => {
                if (subGroupShellItemIndex === subGroupShellIndex) {
                  return {
                    ...subGroupShellItem,
                    [shellKey]: {
                      ...subGroupShellItem?.[
                        shellKey as DealLaScPartnerBShellKeys
                      ],
                      options:
                        subGroupShellItem?.[
                          shellKey as DealLaScPartnerBShellKeys
                        ]?.options || [],
                      value: (() => {
                        const currentValues =
                          subGroupShellItem?.[
                            shellKey as DealLaScPartnerBShellKeys
                          ]?.value || [];

                        if (currentValues.length > valueIndex) {
                          return currentValues
                            .map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return {
                                  text: valueText,
                                  is_modified: true,
                                };
                              }
                              return valueItem;
                            })
                            .filter((valueItem) => valueItem !== null);
                        }

                        return [
                          ...currentValues,
                          { text: valueText, is_modified: true },
                        ];
                      })(),
                    },
                  };
                }
                return subGroupShellItem;
              }),
            },
          },
        };
      }

      if (partnerCShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Partner Axis": {
              ...data[SECTION_KEYS.dealsLaSc]?.["Partner Axis"],
              "Partner C": data[SECTION_KEYS.dealsLaSc]?.["Partner Axis"]?.[
                "Partner C"
              ].map((subGroupShellItem, subGroupShellItemIndex) => {
                if (subGroupShellItemIndex === subGroupShellIndex) {
                  return {
                    ...subGroupShellItem,
                    [shellKey]: {
                      ...subGroupShellItem?.[
                        shellKey as DealLaScPartnerCShellKeys
                      ],
                      options:
                        subGroupShellItem?.[
                          shellKey as DealLaScPartnerCShellKeys
                        ]?.options || [],
                      value: (() => {
                        const currentValues =
                          subGroupShellItem?.[
                            shellKey as DealLaScPartnerCShellKeys
                          ]?.value || [];

                        if (currentValues.length > valueIndex) {
                          return currentValues
                            .map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return {
                                  text: valueText,
                                  is_modified: true,
                                };
                              }
                              return valueItem;
                            })
                            .filter((valueItem) => valueItem !== null);
                        }

                        return [
                          ...currentValues,
                          { text: valueText, is_modified: true },
                        ];
                      })(),
                    },
                  };
                }
                return subGroupShellItem;
              }),
            },
          },
        };
      }
      return data;
    },

    "Other Financial Terms": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const singleShellKeyList = ["Other Financial Terms"];

      if (singleShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            [shellKey]: {
              ...data[SECTION_KEYS.dealsLaSc]?.[
                shellKey as DealLaScDealTermsSingleTableShellKeys
              ],
              options:
                data[SECTION_KEYS.dealsLaSc]?.[
                  shellKey as DealLaScDealTermsSingleTableShellKeys
                ]?.options || [],
              value:
                [
                  ...(data[SECTION_KEYS.dealsLaSc]?.[
                    shellKey as DealLaScDealTermsSingleTableShellKeys
                  ]?.value || []),
                ].length > valueIndex
                  ? data[SECTION_KEYS.dealsLaSc]?.[
                      shellKey as DealLaScDealTermsSingleTableShellKeys
                    ]?.value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(data[SECTION_KEYS.dealsLaSc]?.[
                        shellKey as DealLaScDealTermsSingleTableShellKeys
                      ]?.value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        };
      }
      return data;
    },

    "Main Financial Terms Table": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const singleShellKeyList = [
        "Deal Purpose",
        "Additional Information",
        "Other Financial Terms",
      ];

      const mainFinancialTermsShellKeyList = [
        "Disclosed Payment Sum(LA&SC)",
        "Paying Partner Axis(LA&SC)",
        "Receiving Partner Axis(LA&SC)",
        "Total Payment(LA&SC)",
        "Upfront Payment(LA&SC)",
      ];
      const milestonePaymentShellKeyList = [
        "Milestone Payment(LA&SC)",
        "Milestone Payment Detail(LA&SC)",
      ];
      const royaltyShellKeyList = ["Royalty Rate", "Royalty Detail"];
      const otherPaymentShellKeyList = [
        "Other Payment(LA&SC)",
        "Other Payment Detail(LA&SC)",
      ];

      if (singleShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            [shellKey]: {
              ...data[SECTION_KEYS.dealsLaSc]?.[
                shellKey as DealLaScDealTermsSingleTableShellKeys
              ],
              options:
                data[SECTION_KEYS.dealsLaSc]?.[
                  shellKey as DealLaScDealTermsSingleTableShellKeys
                ]?.options || [],
              value:
                [
                  ...(data[SECTION_KEYS.dealsLaSc]?.[
                    shellKey as DealLaScDealTermsSingleTableShellKeys
                  ]?.value || []),
                ].length > valueIndex
                  ? data[SECTION_KEYS.dealsLaSc]?.[
                      shellKey as DealLaScDealTermsSingleTableShellKeys
                    ]?.value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(data[SECTION_KEYS.dealsLaSc]?.[
                        shellKey as DealLaScDealTermsSingleTableShellKeys
                      ]?.value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        };
      }
      if (mainFinancialTermsShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Main Financial Terms Table": data[SECTION_KEYS.dealsLaSc]?.[
              "Main Financial Terms Table"
            ]?.map((tableItem, tableItemIndex) => {
              if (tableItemIndex === groupShellIndex) {
                return {
                  ...tableItem,
                  [shellKey]: {
                    ...tableItem?.[
                      shellKey as DealLaScMainFinancialTermsTableShellKeys
                    ],
                    options:
                      tableItem?.[
                        shellKey as DealLaScMainFinancialTermsTableShellKeys
                      ]?.options || [],
                    value:
                      [
                        ...(tableItem?.[
                          shellKey as DealLaScMainFinancialTermsTableShellKeys
                        ]?.value || []),
                      ].length > valueIndex
                        ? tableItem?.[
                            shellKey as DealLaScMainFinancialTermsTableShellKeys
                          ]?.value
                            .map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  if (valueText === "") {
                                    return null;
                                  }
                                  return {
                                    text: valueText,
                                    is_modified: true,
                                  };
                                }
                                return valueItem;
                              },
                            )
                            .filter((valueItem) => valueItem !== null)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...(tableItem?.[
                              shellKey as DealLaScMainFinancialTermsTableShellKeys
                            ]?.value || []),
                            { text: valueText, is_modified: true },
                          ]
                            .map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  if (valueText === "") {
                                    return null;
                                  }
                                  return {
                                    text: valueText,
                                    is_modified: true,
                                  };
                                }
                                return valueItem;
                              },
                            )
                            .filter((valueItem) => valueItem !== null)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }
              return tableItem;
            }),
          },
        };
      }
      if (milestonePaymentShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Main Financial Terms Table": data[SECTION_KEYS.dealsLaSc]?.[
              "Main Financial Terms Table"
            ]?.map((groupShellItem, groupShellItemIndex) => {
              if (groupShellItemIndex === groupShellIndex) {
                return {
                  ...groupShellItem,
                  "Milestone Payment And Detail": groupShellItem[
                    "Milestone Payment And Detail"
                  ].map((subGroupShellItem, subGroupShellItemIndex) => {
                    if (subGroupShellItemIndex === subGroupShellIndex) {
                      return {
                        ...subGroupShellItem,
                        [shellKey]: {
                          ...subGroupShellItem?.[
                            shellKey as DealLaScMilestonePaymentShellKeys
                          ],
                          options:
                            subGroupShellItem?.[
                              shellKey as DealLaScMilestonePaymentShellKeys
                            ]?.options || [],
                          value: (() => {
                            const currentValues =
                              subGroupShellItem?.[
                                shellKey as DealLaScMilestonePaymentShellKeys
                              ]?.value || [];

                            if (currentValues.length > valueIndex) {
                              return currentValues
                                .map((valueItem, valueItemIndex) => {
                                  if (valueItemIndex === valueIndex) {
                                    if (valueText === "") {
                                      return null;
                                    }
                                    return {
                                      text: valueText,
                                      is_modified: true,
                                    };
                                  }
                                  return valueItem;
                                })
                                .filter((valueItem) => valueItem !== null);
                            }

                            return [
                              ...currentValues,
                              { text: valueText, is_modified: true },
                            ];
                          })(),
                        },
                      };
                    }
                    return subGroupShellItem;
                  }),
                };
              }
              return groupShellItem;
            }),
          },
        };
      }
      if (royaltyShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Main Financial Terms Table": data[SECTION_KEYS.dealsLaSc]?.[
              "Main Financial Terms Table"
            ]?.map((groupShellItem, groupShellItemIndex) => {
              if (groupShellItemIndex === groupShellIndex) {
                return {
                  ...groupShellItem,
                  "Royalty(LA&SC)": groupShellItem["Royalty(LA&SC)"].map(
                    (subGroupShellItem, subGroupShellItemIndex) => {
                      if (subGroupShellItemIndex === subGroupShellIndex) {
                        return {
                          ...subGroupShellItem,
                          [shellKey]: {
                            ...subGroupShellItem?.[
                              shellKey as DealLaScRoyaltyShellKeys
                            ],
                            options:
                              subGroupShellItem?.[
                                shellKey as DealLaScRoyaltyShellKeys
                              ]?.options || [],
                            value: (() => {
                              const currentValues =
                                subGroupShellItem?.[
                                  shellKey as DealLaScRoyaltyShellKeys
                                ]?.value || [];

                              if (currentValues.length > valueIndex) {
                                return currentValues
                                  .map((valueItem, valueItemIndex) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  })
                                  .filter((valueItem) => valueItem !== null);
                              }

                              return [
                                ...currentValues,
                                { text: valueText, is_modified: true },
                              ];
                            })(),
                          },
                        };
                      }
                      return subGroupShellItem;
                    },
                  ),
                };
              }
              return groupShellItem;
            }),
          },
        };
      }
      if (otherPaymentShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Main Financial Terms Table": data[SECTION_KEYS.dealsLaSc]?.[
              "Main Financial Terms Table"
            ]?.map((groupShellItem, groupShellItemIndex) => {
              if (groupShellItemIndex === groupShellIndex) {
                return {
                  ...groupShellItem,
                  "Other Payment And Detail": groupShellItem[
                    "Other Payment And Detail"
                  ].map((subGroupShellItem, subGroupShellItemIndex) => {
                    if (subGroupShellItemIndex === subGroupShellIndex) {
                      return {
                        ...subGroupShellItem,
                        [shellKey]: {
                          ...subGroupShellItem?.[
                            shellKey as DealLaScOtherPaymentShellKeys
                          ],
                          options:
                            subGroupShellItem?.[
                              shellKey as DealLaScOtherPaymentShellKeys
                            ]?.options || [],
                          value: (() => {
                            const currentValues =
                              subGroupShellItem?.[
                                shellKey as DealLaScOtherPaymentShellKeys
                              ]?.value || [];

                            if (currentValues.length > valueIndex) {
                              return currentValues
                                .map((valueItem, valueItemIndex) => {
                                  if (valueItemIndex === valueIndex) {
                                    if (valueText === "") {
                                      return null;
                                    }
                                    return {
                                      text: valueText,
                                      is_modified: true,
                                    };
                                  }
                                  return valueItem;
                                })
                                .filter((valueItem) => valueItem !== null);
                            }

                            return [
                              ...currentValues,
                              { text: valueText, is_modified: true },
                            ];
                          })(),
                        },
                      };
                    }
                    return subGroupShellItem;
                  }),
                };
              }
              return groupShellItem;
            }),
          },
        };
      }
      return data;
    },

    "Rights Scope Table": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const rightsScopeShellKeyList = [
        "Asset",
        "Exclusivity",
        "Intended Use",
        "Rights Limitation",
        "Rights Scope",
        "Rights Scope Type",
        "Territory",
        "Territory Exclude",
        "Territory Include",
      ];
      const rightsFlowShellKeyList = [
        "Axis Direction",
        "Benefiting Axis",
        "Contributing Axis",
      ];

      if (rightsScopeShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Rights Scope Table": data[SECTION_KEYS.dealsLaSc]?.[
              "Rights Scope Table"
            ]?.map((tableItem, tableItemIndex) => {
              if (tableItemIndex === subGroupShellIndex) {
                if (shellKey === "Rights Scope Type") {
                  return {
                    ...tableItem,
                    [shellKey]: {
                      ...tableItem?.[
                        shellKey as DealLaScDealTermsRightsScopeTableShellKeys
                      ],
                      options:
                        tableItem?.[
                          shellKey as DealLaScDealTermsRightsScopeTableShellKeys
                        ]?.options || [],
                      value: (() => {
                        const currentValues =
                          tableItem?.[
                            shellKey as DealLaScDealTermsRightsScopeTableShellKeys
                          ]?.value || [];

                        if (currentValues.length > valueIndex) {
                          return currentValues
                            .map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }
                              return valueItem;
                            })
                            .filter((valueItem) => valueItem !== null);
                        }

                        return [
                          ...currentValues,
                          { text: valueText, is_modified: true },
                        ];
                      })(),
                    },
                    "Rights Flow": {
                      ...tableItem?.["Rights Flow"],
                      "Benefiting Axis": {
                        ...tableItem?.["Rights Flow"]?.[
                          "Benefiting Axis" as DealLaScDealTermsRightsFlowShellKeys
                        ],
                        // NOTE: collaboration 값이면, Rights Flow의 Benefiting Axis는 빈 배열로 초기화, 아니면 기존 값 유지
                        value:
                          valueText.toLowerCase().trim() === "collaboration"
                            ? []
                            : tableItem?.["Rights Flow"]?.[
                                "Benefiting Axis" as DealLaScDealTermsRightsFlowShellKeys
                              ].value || [],
                      },
                      "Axis Direction": {
                        ...tableItem?.["Rights Flow"]?.[
                          "Axis Direction" as DealLaScDealTermsRightsFlowShellKeys
                        ],
                        value: (() => {
                          const currentValues =
                            tableItem?.["Rights Flow"]?.["Axis Direction"]
                              ?.value || [];
                          const targetAxisDirection =
                            valueText.toLowerCase().trim() === "collaboration"
                              ? ""
                              : "RIGHT_ARROW";

                          if (currentValues.length > valueIndex) {
                            return currentValues
                              .map((valueItem, valueItemIndex) => {
                                if (valueItemIndex === valueIndex) {
                                  if (targetAxisDirection === "") {
                                    return null;
                                  }
                                  return {
                                    text: targetAxisDirection,
                                    is_modified: true,
                                  };
                                }
                                return valueItem;
                              })
                              .filter((valueItem) => valueItem !== null);
                          }

                          return [
                            ...currentValues,
                            { text: targetAxisDirection, is_modified: true },
                          ];
                        })(),
                      },
                    },
                  };
                }
                return {
                  ...tableItem,
                  [shellKey]: {
                    ...tableItem?.[
                      shellKey as DealLaScDealTermsRightsScopeTableShellKeys
                    ],
                    options:
                      tableItem?.[
                        shellKey as DealLaScDealTermsRightsScopeTableShellKeys
                      ]?.options || [],
                    value: (() => {
                      const currentValues =
                        tableItem?.[
                          shellKey as DealLaScDealTermsRightsScopeTableShellKeys
                        ]?.value || [];

                      if (currentValues.length > valueIndex) {
                        return currentValues
                          .map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }
                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null);
                      }

                      return [
                        ...currentValues,
                        { text: valueText, is_modified: true },
                      ];
                    })(),
                  },
                };
              }
              return tableItem;
            }),
          },
        };
      }
      if (rightsFlowShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Rights Scope Table": data[SECTION_KEYS.dealsLaSc]?.[
              "Rights Scope Table"
            ]?.map((tableItem, tableItemIndex) => {
              if (tableItemIndex === subGroupShellIndex) {
                return {
                  ...tableItem,
                  "Rights Flow": {
                    ...tableItem?.["Rights Flow"],
                    [shellKey]: {
                      ...tableItem?.["Rights Flow"]?.[
                        shellKey as DealLaScDealTermsRightsFlowShellKeys
                      ],
                      options:
                        tableItem?.["Rights Flow"]?.[
                          shellKey as DealLaScDealTermsRightsFlowShellKeys
                        ]?.options || [],
                      value:
                        [
                          ...(tableItem?.["Rights Flow"]?.[
                            shellKey as DealLaScDealTermsRightsFlowShellKeys
                          ]?.value || []),
                        ].length > valueIndex
                          ? tableItem?.["Rights Flow"]?.[
                              shellKey as DealLaScDealTermsRightsFlowShellKeys
                            ]?.value
                              .map(
                                (
                                  valueItem: {
                                    text: string;
                                    is_modified: boolean;
                                  },
                                  valueItemIndex: number,
                                ) => {
                                  if (valueItemIndex === valueIndex) {
                                    if (valueText === "") {
                                      return null;
                                    }
                                    return {
                                      text: valueText,
                                      is_modified: true,
                                    };
                                  }
                                  return valueItem;
                                },
                              )
                              .filter((valueItem) => valueItem !== null)
                              .filter(
                                (valueItem, valueItemIndex, valueList) => {
                                  const lastValueIndex = valueList.findIndex(
                                    (target) =>
                                      target?.text.toLowerCase() ===
                                      valueItem?.text.toLowerCase(),
                                  );
                                  return valueItemIndex === lastValueIndex;
                                },
                              )
                          : [
                              ...(tableItem?.["Rights Flow"]?.[
                                shellKey as DealLaScDealTermsRightsFlowShellKeys
                              ]?.value || []),
                              { text: valueText, is_modified: true },
                            ]
                              .map(
                                (
                                  valueItem: {
                                    text: string;
                                    is_modified: boolean;
                                  },
                                  valueItemIndex: number,
                                ) => {
                                  if (valueItemIndex === valueIndex) {
                                    if (valueText === "") {
                                      return null;
                                    }
                                    return {
                                      text: valueText,
                                      is_modified: true,
                                    };
                                  }
                                  return valueItem;
                                },
                              )
                              .filter((valueItem) => valueItem !== null)
                              .filter(
                                (valueItem, valueItemIndex, valueList) => {
                                  const lastValueIndex = valueList.findIndex(
                                    (target) =>
                                      target?.text.toLowerCase() ===
                                      valueItem?.text.toLowerCase(),
                                  );
                                  return valueItemIndex === lastValueIndex;
                                },
                              ),
                    },
                  },
                };
              }
              return tableItem;
            }),
          },
        };
      }
      return data;
    },

    "Advisor Table": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const advisorShellKeyList = [
        "Advisor Name",
        "Advisor Role",
        "Party Axis",
      ];

      if (advisorShellKeyList.includes(shellKey)) {
        return {
          ...data,
          [SECTION_KEYS.dealsLaSc]: {
            ...data[SECTION_KEYS.dealsLaSc],
            "Advisor Table": data[SECTION_KEYS.dealsLaSc]?.[
              "Advisor Table"
            ]?.map((tableItem, tableItemIndex) => {
              if (tableItemIndex === subGroupShellIndex) {
                return {
                  ...tableItem,
                  [shellKey]: {
                    ...tableItem?.[shellKey as DealLaScAdvisorShellKeys],
                    options:
                      tableItem?.[shellKey as DealLaScAdvisorShellKeys]
                        ?.options || [],
                    value: (() => {
                      const currentValues =
                        tableItem?.[shellKey as DealLaScAdvisorShellKeys]
                          ?.value || [];

                      if (currentValues.length > valueIndex) {
                        return currentValues
                          .map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }
                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null);
                      }

                      return [
                        ...currentValues,
                        { text: valueText, is_modified: true },
                      ];
                    })(),
                  },
                };
              }
              return tableItem;
            }),
          },
        };
      }
      return data;
    },

    "Key Comment": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        [SECTION_KEYS.dealsLaSc]: {
          ...data[SECTION_KEYS.dealsLaSc],
          "Key Comment": {
            ...data[SECTION_KEYS.dealsLaSc]?.["Key Comment"],
            [shellKey]: {
              ...data[SECTION_KEYS.dealsLaSc]?.["Key Comment"]?.[
                shellKey as ClinicalTrialsKeyCommentShellKey
              ],

              value:
                [
                  ...(data[SECTION_KEYS.dealsLaSc]?.["Key Comment"]?.[
                    shellKey as QuoteAndSpokesPersonType
                  ].value || []),
                ].length > valueIndex
                  ? data[SECTION_KEYS.dealsLaSc]?.["Key Comment"]?.[
                      shellKey as QuoteAndSpokesPersonType
                    ].value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                  : [
                      ...(data[SECTION_KEYS.dealsLaSc]?.["Key Comment"]?.[
                        shellKey as QuoteAndSpokesPersonType
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null),
            },
          },
        },
      } as ArticleEntryData),
  },
  "Deal Filing": {
    "Drug Profile": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      "Deal Filing": {
        ...data["Deal Filing"],
        "Drug Profile": data["Deal Filing"]?.["Drug Profile"]?.map(
          (item, index) => {
            if (index === tableIndex) {
              if (shellKey === "Therapeutic Area") {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createRandomString(8),
                  },
                  "Therapeutic Area": {
                    ...item["Therapeutic Area"],
                    attributionId:
                      item["Therapeutic Area"]?.attributionId ||
                      createRandomString(8),
                    value:
                      item["Therapeutic Area"] &&
                      item["Therapeutic Area"]?.value.length > valueIndex
                        ? item["Therapeutic Area"].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item["Therapeutic Area"].value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [shellKey as DrugProfileShellKeysNotIncludeAttributionId]: {
                  ...item[
                    shellKey as DrugProfileShellKeysNotIncludeAttributionId
                  ],
                  attributionId:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.attributionId || createRandomString(8),
                  value:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ] &&
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.value.length > valueIndex
                      ? item[
                          shellKey as DrugProfileShellKeysNotIncludeAttributionId
                        ].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[
                            shellKey as DrugProfileShellKeysNotIncludeAttributionId
                          ].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }
            return item;
          },
        ),
      },
    }),
    "Deal Type & Status": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      if (shellKey === ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS.dealType) {
        const dealTypeAndStatusData =
          data?.[ENTRY_DATA_SECTION_KEYS.dealFiling]?.[
            ENTRY_DATA_DEAL_TYPE_AND_STATUS
          ];

        const dealTypeShellData =
          data?.[ENTRY_DATA_SECTION_KEYS.dealFiling]?.[
            ENTRY_DATA_DEAL_TYPE_AND_STATUS
          ]?.[ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS.dealType];

        return {
          ...data,
          [ENTRY_DATA_SECTION_KEYS.dealFiling]: {
            ...data[ENTRY_DATA_SECTION_KEYS.dealFiling],
            [ENTRY_DATA_DEAL_TYPE_AND_STATUS]: {
              ...dealTypeAndStatusData,
              [ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS.dealType]: {
                ...dealTypeShellData,
                value:
                  [...(dealTypeShellData?.value || [])].length > valueIndex
                    ? dealTypeShellData?.value
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText.toLocaleLowerCase(),
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...(dealTypeShellData?.value || []),
                        { text: valueText, is_modified: true },
                      ]
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText.toLocaleLowerCase(),
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            },
          },
        } as ArticleEntryData;
      }

      return {
        ...data,
        "Deal Filing": {
          ...data["Deal Filing"],
          "Deal Type & Status": {
            ...data["Deal Filing"]?.["Deal Type & Status"],
            [shellKey]: {
              ...data["Deal Filing"]?.["Deal Type & Status"]?.[
                shellKey as DealTypeAndStatusKey
              ],
              value:
                [
                  ...(data["Deal Filing"]?.["Deal Type & Status"]?.[
                    shellKey as DealTypeAndStatusKey
                  ]?.value || []),
                ].length > valueIndex
                  ? data["Deal Filing"]?.["Deal Type & Status"]?.[
                      shellKey as DealTypeAndStatusKey
                    ]?.value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(data["Deal Filing"]?.["Deal Type & Status"]?.[
                        shellKey as DealTypeAndStatusKey
                      ]?.value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return {
                              text: valueText,
                              is_modified: true,
                            };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },

    "Licensee Table": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const licensorShell =
        shellKey === "Licensor Name" ||
        shellKey === "Licensor Responsibility & Rights";

      const additionalInformationShell =
        shellKey === "Additional Information" ||
        shellKey === "Purpose of the Deal";

      if (licensorShell) {
        const currentLicensorData =
          data["Deal Filing"]?.["Licensor Table"]?.[shellKey];

        return {
          ...data,
          "Deal Filing": {
            ...data["Deal Filing"],
            "Licensor Table": {
              ...data["Deal Filing"]?.["Licensor Table"],
              [shellKey]: {
                ...currentLicensorData,
                value:
                  [...(currentLicensorData?.value || [])].length > valueIndex
                    ? currentLicensorData?.value
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText,
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...(currentLicensorData?.value || []),
                        { text: valueText, is_modified: true },
                      ]
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText,
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            },
          },
        } as ArticleEntryData;
      }

      if (additionalInformationShell) {
        return {
          ...data,
          "Deal Filing": {
            ...data["Deal Filing"],
            "Additional Information (Deal)": {
              ...data["Deal Filing"]?.["Additional Information (Deal)"],
              [shellKey]: {
                ...data["Deal Filing"]?.["Additional Information (Deal)"]?.[
                  shellKey
                ],
                value:
                  [
                    ...(data["Deal Filing"]?.[
                      "Additional Information (Deal)"
                    ]?.[shellKey]?.value || []),
                  ].length > valueIndex
                    ? data["Deal Filing"]?.["Additional Information (Deal)"]?.[
                        shellKey
                      ]?.value
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText,
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...(data["Deal Filing"]?.[
                          "Additional Information (Deal)"
                        ]?.[shellKey]?.value || []),
                        { text: valueText, is_modified: true },
                      ]
                        .map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return {
                                text: valueText,
                                is_modified: true,
                              };
                            }
                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            },
          },
        } as ArticleEntryData;
      }

      return {
        ...data,
        "Deal Filing": {
          ...data["Deal Filing"],
          "Licensee Table": data["Deal Filing"]?.["Licensee Table"]?.map(
            (tableInfo, tableInfoIndex) => {
              if (tableInfoIndex === tableIndex) {
                const scAndLcShell =
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.upfrontPayment ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.totalPaymentScLa ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.royalty ||
                  shellKey ===
                    ENTRY_DATA_MILESTONE_PAYMENT_CONDITION_KEYS.milestonePayment ||
                  shellKey ===
                    ENTRY_DATA_MILESTONE_PAYMENT_CONDITION_KEYS.milestoneConditionTitle ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.otherFinancialTermsScLa ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.licenseeResponsibilityAndRightsScLa ||
                  shellKey ===
                    ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentScLa ||
                  shellKey ===
                    ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentDetailScLa ||
                  shellKey ===
                    ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.disclosedPaymentsSumScLa;

                const isRightsScopeShell =
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.drug ||
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.indication ||
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.exclusivity ||
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.territory ||
                  shellKey === ENTRY_DATA_RIGHTS_SCOPE_KEYS.assetContributor;

                const isMergeAcquisitionShell =
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.licenseeResponsibilityAndRightsMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.numberOfAcquiringShares ||
                  shellKey === MERGE_ACQUISITION_SHELL_KEYS.pricePerShare ||
                  shellKey === MERGE_ACQUISITION_SHELL_KEYS.totalPaymentMa ||
                  shellKey === MERGE_ACQUISITION_SHELL_KEYS.upfrontPaymentMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.upfrontPricePerShareMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.contingentPaymentMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.contingentPricePerShareMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.contingentMilestoneMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.mergerFinancialTermsMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.otherFinancialTermsMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.disclosedPaymentsSumMa ||
                  shellKey ===
                    MERGE_ACQUISITION_SHELL_KEYS.disclosedPaymentsSumPricePerShareMa;

                const isVentureFormationShell =
                  shellKey === VENTURE_FORMATION_SHELL_KEYS.initialInvestment ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.contingentInvestment ||
                  shellKey === VENTURE_FORMATION_SHELL_KEYS.contingentDetail ||
                  shellKey === VENTURE_FORMATION_SHELL_KEYS.totalInvestmentVf ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.disclosedPaymentsSumVf ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.ownershipStructureDetails ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.otherFinancialTermsVf ||
                  shellKey ===
                    VENTURE_FORMATION_SHELL_KEYS.licenseeResponsibilityAndRightsVf;

                if (shellKey === "Licensee Name") {
                  const currentLicenseeName = tableInfo?.["Licensee Name"];

                  return {
                    ...tableInfo,
                    [shellKey]: {
                      ...currentLicenseeName,
                      value:
                        [...(currentLicenseeName?.value || [])].length >
                        valueIndex
                          ? currentLicenseeName?.value
                              .map(
                                (
                                  valueItem: {
                                    text: string;
                                    is_modified: boolean;
                                  },
                                  valueItemIndex: number,
                                ) => {
                                  if (valueItemIndex === valueIndex) {
                                    if (valueText === "") {
                                      return null;
                                    }
                                    return {
                                      text: valueText,
                                      is_modified: true,
                                    };
                                  }
                                  return valueItem;
                                },
                              )
                              .filter((valueItem) => valueItem !== null)
                              .filter(
                                (valueItem, valueItemIndex, valueList) => {
                                  const lastValueIndex = valueList.findIndex(
                                    (target) =>
                                      target?.text.toLowerCase() ===
                                      valueItem?.text.toLowerCase(),
                                  );
                                  return valueItemIndex === lastValueIndex;
                                },
                              )
                          : [
                              ...(currentLicenseeName?.value || []),
                              { text: valueText, is_modified: true },
                            ]
                              .map(
                                (
                                  valueItem: {
                                    text: string;
                                    is_modified: boolean;
                                  },
                                  valueItemIndex: number,
                                ) => {
                                  if (valueItemIndex === valueIndex) {
                                    if (valueText === "") {
                                      return null;
                                    }
                                    return {
                                      text: valueText,
                                      is_modified: true,
                                    };
                                  }
                                  return valueItem;
                                },
                              )
                              .filter((valueItem) => valueItem !== null)
                              .filter(
                                (valueItem, valueItemIndex, valueList) => {
                                  const lastValueIndex = valueList.findIndex(
                                    (target) =>
                                      target?.text.toLowerCase() ===
                                      valueItem?.text.toLowerCase(),
                                  );
                                  return valueItemIndex === lastValueIndex;
                                },
                              ),
                    },
                  };
                }

                if (isRightsScopeShell) {
                  return {
                    ...tableInfo,
                    "Rights Scope": tableInfo["Rights Scope"]?.map(
                      (groupShellInfo, groupShellInfoIndex) => {
                        if (groupShellInfoIndex === groupShellIndex) {
                          const currentRightsScopeShell =
                            groupShellInfo?.[shellKey];

                          return {
                            ...groupShellInfo,
                            [shellKey]: {
                              ...currentRightsScopeShell,
                              value:
                                [...(currentRightsScopeShell?.value || [])]
                                  .length > valueIndex
                                  ? currentRightsScopeShell?.value
                                      .map(
                                        (
                                          valueItem: {
                                            text: string;
                                            is_modified: boolean;
                                          },
                                          valueItemIndex: number,
                                        ) => {
                                          if (valueItemIndex === valueIndex) {
                                            if (valueText === "") {
                                              return null;
                                            }
                                            return {
                                              text: valueText,
                                              is_modified: true,
                                            };
                                          }
                                          return valueItem;
                                        },
                                      )
                                      .filter((valueItem) => valueItem !== null)
                                      .filter(
                                        (
                                          valueItem,
                                          valueItemIndex,
                                          valueList,
                                        ) => {
                                          const lastValueIndex =
                                            valueList.findIndex(
                                              (target) =>
                                                target?.text.toLowerCase() ===
                                                valueItem?.text.toLowerCase(),
                                            );
                                          return (
                                            valueItemIndex === lastValueIndex
                                          );
                                        },
                                      )
                                  : [
                                      ...(currentRightsScopeShell?.value || []),
                                      { text: valueText, is_modified: true },
                                    ]
                                      .map(
                                        (
                                          valueItem: {
                                            text: string;
                                            is_modified: boolean;
                                          },
                                          valueItemIndex: number,
                                        ) => {
                                          if (valueItemIndex === valueIndex) {
                                            if (valueText === "") {
                                              return null;
                                            }
                                            return {
                                              text: valueText,
                                              is_modified: true,
                                            };
                                          }
                                          return valueItem;
                                        },
                                      )
                                      .filter((valueItem) => valueItem !== null)
                                      .filter(
                                        (
                                          valueItem,
                                          valueItemIndex,
                                          valueList,
                                        ) => {
                                          const lastValueIndex =
                                            valueList.findIndex(
                                              (target) =>
                                                target?.text.toLowerCase() ===
                                                valueItem?.text.toLowerCase(),
                                            );
                                          return (
                                            valueItemIndex === lastValueIndex
                                          );
                                        },
                                      ),
                            },
                          };
                        }

                        return groupShellInfo;
                      },
                    ),
                  };
                }

                if (isMergeAcquisitionShell) {
                  const currentMerge =
                    tableInfo?.[
                      ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms
                    ];

                  const isContingentPaymentShellKeyList =
                    shellKey ===
                      MERGE_ACQUISITION_SHELL_KEYS.contingentPaymentMa ||
                    shellKey ===
                      MERGE_ACQUISITION_SHELL_KEYS.contingentPricePerShareMa ||
                    shellKey ===
                      MERGE_ACQUISITION_SHELL_KEYS.contingentMilestoneMa;

                  if (isContingentPaymentShellKeyList)
                    return {
                      ...tableInfo,
                      [ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms]: {
                        ...currentMerge,
                        [ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS.contingentPayment]:
                          tableInfo[
                            ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms
                          ][
                            ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS
                              .contingentPayment
                          ]?.map(
                            (subGroupShellInfo, subGroupShellInfoIndex) => {
                              if (
                                subGroupShellInfoIndex === subGroupShellIndex
                              ) {
                                const currentContingentPaymentShell =
                                  subGroupShellInfo?.[shellKey];

                                return {
                                  ...subGroupShellInfo,
                                  [shellKey]: {
                                    ...currentContingentPaymentShell,
                                    value:
                                      [
                                        ...(currentContingentPaymentShell?.value ||
                                          []),
                                      ].length > valueIndex
                                        ? currentContingentPaymentShell?.value
                                            .map(
                                              (
                                                valueItem: {
                                                  text: string;
                                                  is_modified: boolean;
                                                },
                                                valueItemIndex: number,
                                              ) => {
                                                if (
                                                  valueItemIndex === valueIndex
                                                ) {
                                                  if (valueText === "") {
                                                    return null;
                                                  }
                                                  return {
                                                    text: valueText,
                                                    is_modified: true,
                                                  };
                                                }
                                                return valueItem;
                                              },
                                            )
                                            .filter(
                                              (valueItem) => valueItem !== null,
                                            )
                                            .filter(
                                              (
                                                valueItem,
                                                valueItemIndex,
                                                valueList,
                                              ) => {
                                                const lastValueIndex =
                                                  valueList.findIndex(
                                                    (target) =>
                                                      target?.text.toLowerCase() ===
                                                      valueItem?.text.toLowerCase(),
                                                  );
                                                return (
                                                  valueItemIndex ===
                                                  lastValueIndex
                                                );
                                              },
                                            )
                                        : [
                                            ...(currentContingentPaymentShell?.value ||
                                              []),
                                            {
                                              text: valueText,
                                              is_modified: true,
                                            },
                                          ]
                                            .map(
                                              (
                                                valueItem: {
                                                  text: string;
                                                  is_modified: boolean;
                                                },
                                                valueItemIndex: number,
                                              ) => {
                                                if (
                                                  valueItemIndex === valueIndex
                                                ) {
                                                  if (valueText === "") {
                                                    return null;
                                                  }
                                                  return {
                                                    text: valueText,
                                                    is_modified: true,
                                                  };
                                                }
                                                return valueItem;
                                              },
                                            )
                                            .filter(
                                              (valueItem) => valueItem !== null,
                                            )
                                            .filter(
                                              (
                                                valueItem,
                                                valueItemIndex,
                                                valueList,
                                              ) => {
                                                const lastValueIndex =
                                                  valueList.findIndex(
                                                    (target) =>
                                                      target?.text.toLowerCase() ===
                                                      valueItem?.text.toLowerCase(),
                                                  );
                                                return (
                                                  valueItemIndex ===
                                                  lastValueIndex
                                                );
                                              },
                                            ),
                                  },
                                };
                              }

                              return subGroupShellInfo;
                            },
                          ),
                      },
                    };

                  return {
                    ...tableInfo,
                    [ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms]: {
                      ...currentMerge,
                      [shellKey]: {
                        ...currentMerge?.[shellKey],
                        value:
                          [...(currentMerge?.[shellKey]?.value || [])].length >
                          valueIndex
                            ? currentMerge?.[shellKey]?.value
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                )
                            : [
                                ...(currentMerge?.[shellKey]?.value || []),
                                { text: valueText, is_modified: true },
                              ]
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                ),
                      },
                    },
                  };
                }

                if (isVentureFormationShell) {
                  const currentVentureFormation =
                    tableInfo?.[
                      ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms
                    ];

                  const isContingentPaymentShellKeyList =
                    shellKey ===
                      VENTURE_FORMATION_SHELL_KEYS.contingentInvestment ||
                    shellKey === VENTURE_FORMATION_SHELL_KEYS.contingentDetail;

                  if (isContingentPaymentShellKeyList)
                    return {
                      ...tableInfo,
                      [ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms]: {
                        ...currentVentureFormation,
                        [ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentInvestmentAndDetailVf]:
                          tableInfo[
                            ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms
                          ][
                            ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS
                              .contingentInvestmentAndDetailVf
                          ]?.map(
                            (subGroupShellInfo, subGroupShellInfoIndex) => {
                              if (
                                subGroupShellInfoIndex === subGroupShellIndex
                              ) {
                                const currentShell =
                                  subGroupShellInfo?.[shellKey];

                                return {
                                  ...subGroupShellInfo,
                                  [shellKey]: {
                                    ...currentShell,
                                    value:
                                      [...(currentShell?.value || [])].length >
                                      valueIndex
                                        ? currentShell?.value
                                            .map(
                                              (
                                                valueItem: {
                                                  text: string;
                                                  is_modified: boolean;
                                                },
                                                valueItemIndex: number,
                                              ) => {
                                                if (
                                                  valueItemIndex === valueIndex
                                                ) {
                                                  if (valueText === "") {
                                                    return null;
                                                  }
                                                  return {
                                                    text: valueText,
                                                    is_modified: true,
                                                  };
                                                }
                                                return valueItem;
                                              },
                                            )
                                            .filter(
                                              (valueItem) => valueItem !== null,
                                            )
                                            .filter(
                                              (
                                                valueItem,
                                                valueItemIndex,
                                                valueList,
                                              ) => {
                                                const lastValueIndex =
                                                  valueList.findIndex(
                                                    (target) =>
                                                      target?.text.toLowerCase() ===
                                                      valueItem?.text.toLowerCase(),
                                                  );
                                                return (
                                                  valueItemIndex ===
                                                  lastValueIndex
                                                );
                                              },
                                            )
                                        : [
                                            ...(currentShell?.value || []),
                                            {
                                              text: valueText,
                                              is_modified: true,
                                            },
                                          ]
                                            .map(
                                              (
                                                valueItem: {
                                                  text: string;
                                                  is_modified: boolean;
                                                },
                                                valueItemIndex: number,
                                              ) => {
                                                if (
                                                  valueItemIndex === valueIndex
                                                ) {
                                                  if (valueText === "") {
                                                    return null;
                                                  }
                                                  return {
                                                    text: valueText,
                                                    is_modified: true,
                                                  };
                                                }
                                                return valueItem;
                                              },
                                            )
                                            .filter(
                                              (valueItem) => valueItem !== null,
                                            )
                                            .filter(
                                              (
                                                valueItem,
                                                valueItemIndex,
                                                valueList,
                                              ) => {
                                                const lastValueIndex =
                                                  valueList.findIndex(
                                                    (target) =>
                                                      target?.text.toLowerCase() ===
                                                      valueItem?.text.toLowerCase(),
                                                  );
                                                return (
                                                  valueItemIndex ===
                                                  lastValueIndex
                                                );
                                              },
                                            ),
                                  },
                                };
                              }

                              return subGroupShellInfo;
                            },
                          ),
                      },
                    };

                  return {
                    ...tableInfo,
                    [ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms]: {
                      ...currentVentureFormation,
                      [shellKey]: {
                        ...currentVentureFormation?.[shellKey],
                        value:
                          [
                            ...(currentVentureFormation?.[shellKey]?.value ||
                              []),
                          ].length > valueIndex
                            ? currentVentureFormation?.[shellKey]?.value
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                )
                            : [
                                ...(currentVentureFormation?.[shellKey]
                                  ?.value || []),
                                { text: valueText, is_modified: true },
                              ]
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                ),
                      },
                    },
                  };
                }

                if (scAndLcShell) {
                  const currentScAndLa =
                    tableInfo[
                      "Strategic Collaboration & License Agreement terms"
                    ];

                  const isMilestoneShell =
                    shellKey ===
                      ENTRY_DATA_MILESTONE_PAYMENT_CONDITION_KEYS.milestonePayment ||
                    shellKey ===
                      ENTRY_DATA_MILESTONE_PAYMENT_CONDITION_KEYS.milestoneConditionTitle;

                  const isOtherPaymentAndDetailShell =
                    shellKey ===
                      ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentScLa ||
                    shellKey ===
                      ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentDetailScLa;

                  // NOTE : 대문자로 변경

                  if (isMilestoneShell) {
                    return {
                      ...tableInfo,
                      "Strategic Collaboration & License Agreement terms": {
                        ...currentScAndLa,
                        "Milestone Payment and Condition": currentScAndLa[
                          "Milestone Payment and Condition"
                        ]?.map((subGroupShellInfo, subGroupShellInfoIndex) => {
                          if (subGroupShellInfoIndex === subGroupShellIndex) {
                            const currentMilestone =
                              subGroupShellInfo?.[shellKey];

                            return {
                              ...subGroupShellInfo,
                              [shellKey]: {
                                ...currentMilestone,
                                value:
                                  valueText !== ""
                                    ? [
                                        {
                                          text: valueText,
                                          is_modified: true,
                                        },
                                      ]
                                    : [],
                              },
                            };
                          }
                          return subGroupShellInfo;
                        }),
                      },
                    };
                  }

                  if (isOtherPaymentAndDetailShell) {
                    return {
                      ...tableInfo,
                      [ENTRY_DATA_LICENSEE_TABLE_KEYS.strategicCollaborationLicenseAgreementTerms]:
                        {
                          ...currentScAndLa,
                          [ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS.otherPaymentAndDetailScLa]:
                            currentScAndLa[
                              ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS
                                .otherPaymentAndDetailScLa
                            ]?.map(
                              (subGroupShellInfo, subGroupShellInfoIndex) => {
                                if (
                                  subGroupShellInfoIndex === subGroupShellIndex
                                ) {
                                  const currentOtherPaymentShell =
                                    subGroupShellInfo?.[shellKey];

                                  return {
                                    ...subGroupShellInfo,
                                    [shellKey]: {
                                      ...currentOtherPaymentShell,
                                      value:
                                        valueText !== ""
                                          ? [
                                              {
                                                text: valueText,
                                                is_modified: true,
                                              },
                                            ]
                                          : [],
                                    },
                                  };
                                }
                                return subGroupShellInfo;
                              },
                            ),
                        },
                    };
                  }

                  return {
                    ...tableInfo,
                    "Strategic Collaboration & License Agreement terms": {
                      ...currentScAndLa,
                      [shellKey]: {
                        ...currentScAndLa?.[shellKey],
                        value:
                          [...(currentScAndLa?.[shellKey]?.value || [])]
                            .length > valueIndex
                            ? currentScAndLa?.[shellKey]?.value
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                )
                            : [
                                ...(currentScAndLa?.[shellKey]?.value || []),
                                { text: valueText, is_modified: true },
                              ]
                                .map(
                                  (
                                    valueItem: {
                                      text: string;
                                      is_modified: boolean;
                                    },
                                    valueItemIndex: number,
                                  ) => {
                                    if (valueItemIndex === valueIndex) {
                                      if (valueText === "") {
                                        return null;
                                      }
                                      return {
                                        text: valueText,
                                        is_modified: true,
                                      };
                                    }
                                    return valueItem;
                                  },
                                )
                                .filter((valueItem) => valueItem !== null)
                                .filter(
                                  (valueItem, valueItemIndex, valueList) => {
                                    const lastValueIndex = valueList.findIndex(
                                      (target) =>
                                        target?.text.toLowerCase() ===
                                        valueItem?.text.toLowerCase(),
                                    );
                                    return valueItemIndex === lastValueIndex;
                                  },
                                ),
                      },
                    },
                  };
                }
              }

              return tableInfo;
            },
          ),
        },
      } as ArticleEntryData;
    },
    "Key Comment": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        "Deal Filing": {
          ...data["Deal Filing"],
          "Key Comment": {
            ...data["Deal Filing"]?.["Key Comment"],
            [shellKey]: {
              ...data["Deal Filing"]?.["Key Comment"]?.[
                shellKey as ClinicalTrialsKeyCommentShellKey
              ],

              value:
                [
                  ...(data["Deal Filing"]?.["Key Comment"]?.[
                    shellKey as QuoteAndSpokesPersonType
                  ].value || []),
                ].length > valueIndex
                  ? data["Deal Filing"]?.["Key Comment"]?.[
                      shellKey as QuoteAndSpokesPersonType
                    ].value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                  : [
                      ...(data["Deal Filing"]?.["Key Comment"]?.[
                        shellKey as QuoteAndSpokesPersonType
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null),
            },
          },
        },
      } as ArticleEntryData),
  },
  [EXPEDITED_PROGRAM]: {
    [eg.drugProfile]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      [EXPEDITED_PROGRAM]: {
        ...data[EXPEDITED_PROGRAM],
        [eg.drugProfile]: data[EXPEDITED_PROGRAM]?.[eg.drugProfile]?.map(
          (item, index) => {
            if (index === tableIndex) {
              if (shellKey === "Therapeutic Area") {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createRandomString(8),
                  },
                  "Therapeutic Area": {
                    ...item["Therapeutic Area"],
                    attributionId:
                      item["Therapeutic Area"]?.attributionId ||
                      createRandomString(8),
                    value:
                      item["Therapeutic Area"] &&
                      item["Therapeutic Area"]?.value.length > valueIndex
                        ? item["Therapeutic Area"].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item["Therapeutic Area"].value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [shellKey as ExpeditedProgramDrugProfileShellKeysNotAttributionId]:
                  {
                    ...item[
                      shellKey as ExpeditedProgramDrugProfileShellKeysNotAttributionId
                    ],
                    attributionId:
                      item[
                        shellKey as ExpeditedProgramDrugProfileShellKeysNotAttributionId
                      ]?.attributionId || createRandomString(8),
                    value:
                      item[
                        shellKey as ExpeditedProgramDrugProfileShellKeysNotAttributionId
                      ] &&
                      item[
                        shellKey as ExpeditedProgramDrugProfileShellKeysNotAttributionId
                      ]?.value.length > valueIndex
                        ? item[
                            shellKey as ExpeditedProgramDrugProfileShellKeysNotAttributionId
                          ].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => valueItem !== null)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item[
                              shellKey as ExpeditedProgramDrugProfileShellKeysNotAttributionId
                            ].value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  if (valueText === "") {
                                    return null;
                                  }
                                  return { text: valueText, is_modified: true };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => valueItem !== null)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
              };
            }
            return item;
          },
        ),
      },
    }),
    [eg.expeditedProgramContents]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => ({
      ...data,
      [EXPEDITED_PROGRAM]: {
        ...data[EXPEDITED_PROGRAM],
        [eg.expeditedProgramContents]: data[EXPEDITED_PROGRAM]?.[
          eg.expeditedProgramContents
        ]?.map((item, index) => {
          if (index === tableIndex) {
            return {
              ...item,
              attributionInfo: {
                attributionId:
                  item?.attributionInfo?.attributionId || createRandomString(8),
              },
              [shellKey as ExpeditedProgramContentsShellKeysNotAttributionId]: {
                ...item[
                  shellKey as ExpeditedProgramContentsShellKeysNotAttributionId
                ],
                attributionId:
                  item[
                    shellKey as ExpeditedProgramContentsShellKeysNotAttributionId
                  ]?.attributionId || createRandomString(8),
                value:
                  item[
                    shellKey as ExpeditedProgramContentsShellKeysNotAttributionId
                  ] &&
                  item[
                    shellKey as ExpeditedProgramContentsShellKeysNotAttributionId
                  ]?.value.length > valueIndex
                    ? item[
                        shellKey as ExpeditedProgramContentsShellKeysNotAttributionId
                      ].value
                        ?.map((valueItem, valueItemIndex) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        })
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...item[
                          shellKey as ExpeditedProgramContentsShellKeysNotAttributionId
                        ].value,
                        { text: valueText, is_modified: true },
                      ]
                        ?.map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            };
          }
          return item;
        }),
      },
    }),

    [eg.keyComment]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        [EXPEDITED_PROGRAM]: {
          ...data[EXPEDITED_PROGRAM],
          [eg.keyComment]: {
            ...data[EXPEDITED_PROGRAM]?.[eg.keyComment],
            [shellKey]: {
              ...data[EXPEDITED_PROGRAM]?.[eg.keyComment]?.[
                shellKey as ExpeditedProgramKeyCommentShellKeys
              ],

              value:
                [
                  ...(data[EXPEDITED_PROGRAM]?.[eg.keyComment]?.[
                    shellKey as QuoteAndSpokesPersonType
                  ].value || []),
                ].length > valueIndex
                  ? data[EXPEDITED_PROGRAM]?.[eg.keyComment]?.[
                      shellKey as QuoteAndSpokesPersonType
                    ].value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                  : [
                      ...(data[EXPEDITED_PROGRAM]?.[eg.keyComment]?.[
                        shellKey as QuoteAndSpokesPersonType
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null),
            },
          },
        },
      } as ArticleEntryData),
  },
  [SECTION_KEYS.ventureCapital]: {
    [DRUG_PROFILE]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      [SECTION_KEYS.ventureCapital]: {
        ...data[SECTION_KEYS.ventureCapital],
        [DRUG_PROFILE]: data[SECTION_KEYS.ventureCapital]?.[DRUG_PROFILE]?.map(
          (item, index) => {
            if (index === tableIndex) {
              if (shellKey === DRUG_PROFILE_SHELL_KEYS.therapeuticArea) {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createAttributionId(),
                  },
                  [DRUG_PROFILE_SHELL_KEYS.therapeuticArea]: {
                    ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea],
                    attributionId:
                      item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                        ?.attributionId || createAttributionId(),
                    value:
                      item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea] &&
                      item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]?.value
                        .length > valueIndex
                        ? item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                              .value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createAttributionId(),
                },
                [shellKey as DrugProfileShellKeysNotIncludeAttributionId]: {
                  ...item[
                    shellKey as DrugProfileShellKeysNotIncludeAttributionId
                  ],
                  attributionId:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.attributionId || createAttributionId(),
                  value:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ] &&
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.value.length > valueIndex
                      ? item[
                          shellKey as DrugProfileShellKeysNotIncludeAttributionId
                        ].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[
                            shellKey as DrugProfileShellKeysNotIncludeAttributionId
                          ].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }
            return item;
          },
        ),
      },
    }),
    [FUNDED_COMPANY]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData = data[SECTION_KEYS.ventureCapital]?.[FUNDED_COMPANY];

      return {
        ...data,
        [SECTION_KEYS.ventureCapital]: {
          ...data[SECTION_KEYS.ventureCapital],
          [FUNDED_COMPANY]: {
            ...currentData,
            [shellKey as VentureCapitalFundedCompanyShellKeys]: {
              ...currentData?.[
                shellKey as VentureCapitalFundedCompanyShellKeys
              ],
              attributionId:
                currentData?.[shellKey as VentureCapitalFundedCompanyShellKeys]
                  ?.attributionId || createAttributionId(),
              value:
                currentData?.[
                  shellKey as VentureCapitalFundedCompanyShellKeys
                ] &&
                currentData?.[shellKey as VentureCapitalFundedCompanyShellKeys]
                  ?.value.length > valueIndex
                  ? currentData?.[
                      shellKey as VentureCapitalFundedCompanyShellKeys
                    ].value
                      ?.map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }

                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(currentData?.[
                        shellKey as VentureCapitalFundedCompanyShellKeys
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      ?.map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },
    [ROUND_TYPE_AND_STATUS]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData =
        data[SECTION_KEYS.ventureCapital]?.[ROUND_TYPE_AND_STATUS];

      return {
        ...data,
        [SECTION_KEYS.ventureCapital]: {
          ...data[SECTION_KEYS.ventureCapital],
          [ROUND_TYPE_AND_STATUS]: {
            ...currentData,
            [shellKey as VentureCapitalRoundTypeAndStatusShellKeys]: {
              ...currentData?.[
                shellKey as VentureCapitalRoundTypeAndStatusShellKeys
              ],
              attributionId:
                currentData?.[
                  shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                ]?.attributionId || createAttributionId(),
              value:
                currentData?.[
                  shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                ] &&
                currentData?.[
                  shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                ]?.value.length > valueIndex
                  ? currentData?.[
                      shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                    ].value
                      ?.map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }

                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(currentData?.[
                        shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      ?.map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },
    [FINANCING_INFORMATION]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData =
        data[SECTION_KEYS.ventureCapital]?.[FINANCING_INFORMATION];

      return {
        ...data,
        [SECTION_KEYS.ventureCapital]: {
          ...data[SECTION_KEYS.ventureCapital],
          [FINANCING_INFORMATION]: {
            ...currentData,
            [shellKey as VentureCapitalFinancingInformationShellKeys]: {
              ...currentData?.[
                shellKey as VentureCapitalFinancingInformationShellKeys
              ],
              attributionId:
                currentData?.[
                  shellKey as VentureCapitalFinancingInformationShellKeys
                ]?.attributionId || createAttributionId(),
              value:
                currentData?.[
                  shellKey as VentureCapitalFinancingInformationShellKeys
                ] &&
                currentData?.[
                  shellKey as VentureCapitalFinancingInformationShellKeys
                ]?.value.length > valueIndex
                  ? currentData?.[
                      shellKey as VentureCapitalFinancingInformationShellKeys
                    ].value
                      ?.map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }

                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(currentData?.[
                        shellKey as VentureCapitalFinancingInformationShellKeys
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      ?.map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },
    [INVESTORS]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData = data[SECTION_KEYS.ventureCapital]?.[INVESTORS];
      const valueLength =
        currentData?.[shellKey as VentureCapitalInvestorsShellKeys]?.value
          .length || 0;

      const shellValueData =
        currentData?.[shellKey as VentureCapitalInvestorsShellKeys] &&
        currentData?.[shellKey as VentureCapitalInvestorsShellKeys]?.value
          .length > valueIndex
          ? currentData?.[shellKey as VentureCapitalInvestorsShellKeys].value
              ?.map((valueItem, valueItemIndex) => {
                if (valueItemIndex === valueIndex) {
                  return {
                    text: valueText,
                    is_modified: true,
                    is_lead_investor:
                      valueText === "" ? false : valueItem.is_lead_investor,
                  };
                }

                return valueItem;
              })
              .filter((valueItem) => valueItem !== null)
          : [
              ...(currentData?.[shellKey as VentureCapitalInvestorsShellKeys]
                .value || []),
              {
                text: valueText,
                is_modified: true,
                is_lead_investor: false,
              },
            ]
              ?.map((valueItem, valueItemIndex) => {
                if (valueItemIndex === valueIndex) {
                  return {
                    text: valueText,
                    is_modified: true,
                    is_lead_investor: false,
                  };
                }

                return valueItem;
              })
              .filter((valueItem) => valueItem !== null);

      const isLastEmptyValue = () => {
        if (valueIndex === valueLength - 1 && valueText !== "") return false;
        return true;
      };

      const uniqueInvestorValue = (investorValue: EntryDataInvestorValue[]) => {
        return investorValue.filter(
          (currentItem, currentIndex, self) =>
            currentItem.text.trim() === "" ||
            currentIndex ===
              self.findIndex((item) => item.text === currentItem.text),
        );
      };

      const updatedEntryData = {
        ...data,
        [SECTION_KEYS.ventureCapital]: {
          ...data[SECTION_KEYS.ventureCapital],
          [INVESTORS]: {
            ...currentData,
            [shellKey as VentureCapitalInvestorsShellKeys]: {
              ...currentData?.[shellKey as VentureCapitalInvestorsShellKeys],
              attributionId:
                currentData?.[shellKey as VentureCapitalInvestorsShellKeys]
                  ?.attributionId || createAttributionId(),
              value: !isLastEmptyValue()
                ? uniqueInvestorValue([
                    ...shellValueData,
                    {
                      text: "",
                      is_modified: true,
                      is_lead_investor: false,
                    },
                  ])
                : uniqueInvestorValue(shellValueData),
            },
          },
        },
      } as ArticleEntryData;

      return updatedEntryData;
    },
    [ADDITIONAL_INFORMATION_VENTURE_CAPITAL]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData =
        data[SECTION_KEYS.ventureCapital]?.[
          ADDITIONAL_INFORMATION_VENTURE_CAPITAL
        ];

      return {
        ...data,
        [SECTION_KEYS.ventureCapital]: {
          ...data[SECTION_KEYS.ventureCapital],
          [ADDITIONAL_INFORMATION_VENTURE_CAPITAL]: {
            ...currentData,
            [shellKey as VentureCapitalAdditionalInformationShellKeys]: {
              ...currentData?.[
                shellKey as VentureCapitalAdditionalInformationShellKeys
              ],
              attributionId:
                currentData?.[
                  shellKey as VentureCapitalAdditionalInformationShellKeys
                ]?.attributionId || createAttributionId(),
              value:
                currentData?.[
                  shellKey as VentureCapitalAdditionalInformationShellKeys
                ] &&
                currentData?.[
                  shellKey as VentureCapitalAdditionalInformationShellKeys
                ]?.value.length > valueIndex
                  ? currentData?.[
                      shellKey as VentureCapitalAdditionalInformationShellKeys
                    ].value
                      ?.map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }

                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(currentData?.[
                        shellKey as VentureCapitalAdditionalInformationShellKeys
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      ?.map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },
    [KEY_COMMENT]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        [SECTION_KEYS.ventureCapital]: {
          ...data[SECTION_KEYS.ventureCapital],
          [KEY_COMMENT]: {
            ...data[SECTION_KEYS.ventureCapital]?.[KEY_COMMENT],
            [shellKey]: {
              ...data[SECTION_KEYS.ventureCapital]?.[KEY_COMMENT]?.[
                shellKey as ClinicalTrialsKeyCommentShellKey
              ],

              value:
                [
                  ...(data[SECTION_KEYS.ventureCapital]?.[KEY_COMMENT]?.[
                    shellKey as QuoteAndSpokesPersonType
                  ].value || []),
                ].length > valueIndex
                  ? data[SECTION_KEYS.ventureCapital]?.[KEY_COMMENT]?.[
                      shellKey as QuoteAndSpokesPersonType
                    ].value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                  : [
                      ...(data[SECTION_KEYS.ventureCapital]?.[KEY_COMMENT]?.[
                        shellKey as QuoteAndSpokesPersonType
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null),
            },
          },
        },
      } as ArticleEntryData),
  },
  [SECTION_KEYS.fundingFiling]: {
    [DRUG_PROFILE]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      [SECTION_KEYS.fundingFiling]: {
        ...data[SECTION_KEYS.fundingFiling],
        [DRUG_PROFILE]: data[SECTION_KEYS.fundingFiling]?.[DRUG_PROFILE]?.map(
          (item, index) => {
            if (index === tableIndex) {
              if (shellKey === DRUG_PROFILE_SHELL_KEYS.therapeuticArea) {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createAttributionId(),
                  },
                  [DRUG_PROFILE_SHELL_KEYS.therapeuticArea]: {
                    ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea],
                    attributionId:
                      item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                        ?.attributionId || createAttributionId(),
                    value:
                      item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea] &&
                      item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]?.value
                        .length > valueIndex
                        ? item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                              .value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createAttributionId(),
                },
                [shellKey as DrugProfileShellKeysNotIncludeAttributionId]: {
                  ...item[
                    shellKey as DrugProfileShellKeysNotIncludeAttributionId
                  ],
                  attributionId:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.attributionId || createAttributionId(),
                  value:
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ] &&
                    item[
                      shellKey as DrugProfileShellKeysNotIncludeAttributionId
                    ]?.value.length > valueIndex
                      ? item[
                          shellKey as DrugProfileShellKeysNotIncludeAttributionId
                        ].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[
                            shellKey as DrugProfileShellKeysNotIncludeAttributionId
                          ].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }
            return item;
          },
        ),
      },
    }),
    [FUNDED_COMPANY]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData = data[SECTION_KEYS.fundingFiling]?.[FUNDED_COMPANY];

      return {
        ...data,
        [SECTION_KEYS.fundingFiling]: {
          ...data[SECTION_KEYS.fundingFiling],
          [FUNDED_COMPANY]: {
            ...currentData,
            [shellKey as VentureCapitalFundedCompanyShellKeys]: {
              ...currentData?.[
                shellKey as VentureCapitalFundedCompanyShellKeys
              ],
              attributionId:
                currentData?.[shellKey as VentureCapitalFundedCompanyShellKeys]
                  ?.attributionId || createAttributionId(),
              value:
                currentData?.[
                  shellKey as VentureCapitalFundedCompanyShellKeys
                ] &&
                currentData?.[shellKey as VentureCapitalFundedCompanyShellKeys]
                  ?.value.length > valueIndex
                  ? currentData?.[
                      shellKey as VentureCapitalFundedCompanyShellKeys
                    ].value
                      ?.map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }

                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(currentData?.[
                        shellKey as VentureCapitalFundedCompanyShellKeys
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      ?.map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },
    [ROUND_TYPE_AND_STATUS]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData =
        data[SECTION_KEYS.fundingFiling]?.[ROUND_TYPE_AND_STATUS];

      return {
        ...data,
        [SECTION_KEYS.fundingFiling]: {
          ...data[SECTION_KEYS.fundingFiling],
          [ROUND_TYPE_AND_STATUS]: {
            ...currentData,
            [shellKey as VentureCapitalRoundTypeAndStatusShellKeys]: {
              ...currentData?.[
                shellKey as VentureCapitalRoundTypeAndStatusShellKeys
              ],
              attributionId:
                currentData?.[
                  shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                ]?.attributionId || createAttributionId(),
              value:
                currentData?.[
                  shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                ] &&
                currentData?.[
                  shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                ]?.value.length > valueIndex
                  ? currentData?.[
                      shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                    ].value
                      ?.map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }

                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(currentData?.[
                        shellKey as VentureCapitalRoundTypeAndStatusShellKeys
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      ?.map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },
    [FINANCING_INFORMATION]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData =
        data[SECTION_KEYS.fundingFiling]?.[FINANCING_INFORMATION];

      return {
        ...data,
        [SECTION_KEYS.fundingFiling]: {
          ...data[SECTION_KEYS.fundingFiling],
          [FINANCING_INFORMATION]: {
            ...currentData,
            [shellKey as VentureCapitalFinancingInformationShellKeys]: {
              ...currentData?.[
                shellKey as VentureCapitalFinancingInformationShellKeys
              ],
              attributionId:
                currentData?.[
                  shellKey as VentureCapitalFinancingInformationShellKeys
                ]?.attributionId || createAttributionId(),
              value:
                currentData?.[
                  shellKey as VentureCapitalFinancingInformationShellKeys
                ] &&
                currentData?.[
                  shellKey as VentureCapitalFinancingInformationShellKeys
                ]?.value.length > valueIndex
                  ? currentData?.[
                      shellKey as VentureCapitalFinancingInformationShellKeys
                    ].value
                      ?.map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }

                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(currentData?.[
                        shellKey as VentureCapitalFinancingInformationShellKeys
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      ?.map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },
    [INVESTORS]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData = data[SECTION_KEYS.fundingFiling]?.[INVESTORS];
      const valueLength =
        currentData?.[shellKey as VentureCapitalInvestorsShellKeys]?.value
          .length || 0;

      const shellValueData =
        currentData?.[shellKey as VentureCapitalInvestorsShellKeys] &&
        currentData?.[shellKey as VentureCapitalInvestorsShellKeys]?.value
          .length > valueIndex
          ? currentData?.[shellKey as VentureCapitalInvestorsShellKeys].value
              ?.map((valueItem, valueItemIndex) => {
                if (valueItemIndex === valueIndex) {
                  return {
                    text: valueText,
                    is_modified: true,
                    is_lead_investor:
                      valueText === "" ? false : valueItem.is_lead_investor,
                  };
                }

                return valueItem;
              })
              .filter((valueItem) => valueItem !== null)
          : [
              ...(currentData?.[shellKey as VentureCapitalInvestorsShellKeys]
                .value || []),
              {
                text: valueText,
                is_modified: true,
                is_lead_investor: false,
              },
            ]
              ?.map((valueItem, valueItemIndex) => {
                if (valueItemIndex === valueIndex) {
                  return {
                    text: valueText,
                    is_modified: true,
                    is_lead_investor: false,
                  };
                }

                return valueItem;
              })
              .filter((valueItem) => valueItem !== null);

      const isLastEmptyValue = () => {
        if (valueIndex === valueLength - 1 && valueText !== "") return false;
        return true;
      };

      const uniqueInvestorValue = (investorValue: EntryDataInvestorValue[]) => {
        return investorValue.filter(
          (currentItem, currentIndex, self) =>
            currentItem.text.trim() === "" ||
            currentIndex ===
              self.findIndex((item) => item.text === currentItem.text),
        );
      };

      const updatedEntryData = {
        ...data,
        [SECTION_KEYS.fundingFiling]: {
          ...data[SECTION_KEYS.fundingFiling],
          [INVESTORS]: {
            ...currentData,
            [shellKey as VentureCapitalInvestorsShellKeys]: {
              ...currentData?.[shellKey as VentureCapitalInvestorsShellKeys],
              attributionId:
                currentData?.[shellKey as VentureCapitalInvestorsShellKeys]
                  ?.attributionId || createAttributionId(),
              value: !isLastEmptyValue()
                ? uniqueInvestorValue([
                    ...shellValueData,
                    {
                      text: "",
                      is_modified: true,
                      is_lead_investor: false,
                    },
                  ])
                : uniqueInvestorValue(shellValueData),
            },
          },
        },
      } as ArticleEntryData;

      return updatedEntryData;
    },
    [ADDITIONAL_INFORMATION_VENTURE_CAPITAL]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) => {
      const currentData =
        data[SECTION_KEYS.fundingFiling]?.[
          ADDITIONAL_INFORMATION_VENTURE_CAPITAL
        ];

      return {
        ...data,
        [SECTION_KEYS.fundingFiling]: {
          ...data[SECTION_KEYS.fundingFiling],
          [ADDITIONAL_INFORMATION_VENTURE_CAPITAL]: {
            ...currentData,
            [shellKey as VentureCapitalAdditionalInformationShellKeys]: {
              ...currentData?.[
                shellKey as VentureCapitalAdditionalInformationShellKeys
              ],
              attributionId:
                currentData?.[
                  shellKey as VentureCapitalAdditionalInformationShellKeys
                ]?.attributionId || createAttributionId(),
              value:
                currentData?.[
                  shellKey as VentureCapitalAdditionalInformationShellKeys
                ] &&
                currentData?.[
                  shellKey as VentureCapitalAdditionalInformationShellKeys
                ]?.value.length > valueIndex
                  ? currentData?.[
                      shellKey as VentureCapitalAdditionalInformationShellKeys
                    ].value
                      ?.map((valueItem, valueItemIndex) => {
                        if (valueItemIndex === valueIndex) {
                          if (valueText === "") {
                            return null;
                          }
                          return { text: valueText, is_modified: true };
                        }

                        return valueItem;
                      })
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      })
                  : [
                      ...(currentData?.[
                        shellKey as VentureCapitalAdditionalInformationShellKeys
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      ?.map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                      .filter((valueItem, valueItemIndex, valueList) => {
                        const lastValueIndex = valueList.findIndex(
                          (target) =>
                            target?.text.toLowerCase() ===
                            valueItem?.text.toLowerCase(),
                        );
                        return valueItemIndex === lastValueIndex;
                      }),
            },
          },
        },
      } as ArticleEntryData;
    },
    [KEY_COMMENT]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
    ) =>
      ({
        ...data,
        [SECTION_KEYS.fundingFiling]: {
          ...data[SECTION_KEYS.fundingFiling],
          [KEY_COMMENT]: {
            ...data[SECTION_KEYS.fundingFiling]?.[KEY_COMMENT],
            [shellKey]: {
              ...data[SECTION_KEYS.fundingFiling]?.[KEY_COMMENT]?.[
                shellKey as ClinicalTrialsKeyCommentShellKey
              ],

              value:
                [
                  ...(data[SECTION_KEYS.fundingFiling]?.[KEY_COMMENT]?.[
                    shellKey as QuoteAndSpokesPersonType
                  ].value || []),
                ].length > valueIndex
                  ? data[SECTION_KEYS.fundingFiling]?.[KEY_COMMENT]?.[
                      shellKey as QuoteAndSpokesPersonType
                    ].value
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null)
                  : [
                      ...(data[SECTION_KEYS.fundingFiling]?.[KEY_COMMENT]?.[
                        shellKey as QuoteAndSpokesPersonType
                      ].value || []),
                      { text: valueText, is_modified: true },
                    ]
                      .map(
                        (
                          valueItem: {
                            text: string;
                            is_modified: boolean;
                          },
                          valueItemIndex: number,
                        ) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }
                          return valueItem;
                        },
                      )
                      .filter((valueItem) => valueItem !== null),
            },
          },
        },
      } as ArticleEntryData),
  },
  [SECTION_KEYS.publication]: {
    [DRUG_PROFILE]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      [SECTION_KEYS.publication]: {
        ...data[SECTION_KEYS.publication],
        [DRUG_PROFILE]: data[SECTION_KEYS.publication]?.[DRUG_PROFILE]?.map(
          (item, index) => {
            const currentShellKey =
              shellKey as DrugProfileShellKeysOnlyEntryDataValue;
            if (index === tableIndex) {
              if (shellKey === DRUG_PROFILE_SHELL_KEYS.therapeuticArea) {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createRandomString(8),
                  },
                  [DRUG_PROFILE_SHELL_KEYS.therapeuticArea]: {
                    ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea],
                    attributionId:
                      item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                        ?.attributionId || createRandomString(8),
                    value:
                      item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea] &&
                      item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]?.value
                        .length > valueIndex
                        ? item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                              .value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [currentShellKey]: {
                  ...item[currentShellKey],
                  attributionId:
                    item[currentShellKey]?.attributionId ||
                    createRandomString(8),
                  value:
                    item[currentShellKey] &&
                    item[currentShellKey]?.value.length > valueIndex
                      ? item[currentShellKey].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[currentShellKey].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }
            return item;
          },
        ),
      },
    }),
  },
  [SECTION_KEYS.publicationJournal]: {
    [DRUG_PROFILE]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      [SECTION_KEYS.publicationJournal]: {
        ...data[SECTION_KEYS.publicationJournal],
        [DRUG_PROFILE]: data[SECTION_KEYS.publicationJournal]?.[
          DRUG_PROFILE
        ]?.map((item, index) => {
          const currentShellKey =
            shellKey as DrugProfileShellKeysOnlyEntryDataValue;
          if (index === tableIndex) {
            if (shellKey === DRUG_PROFILE_SHELL_KEYS.therapeuticArea) {
              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [DRUG_PROFILE_SHELL_KEYS.therapeuticArea]: {
                  ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea],
                  attributionId:
                    item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                      ?.attributionId || createRandomString(8),
                  value:
                    item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea] &&
                    item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]?.value
                      .length > valueIndex
                      ? item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              const checkDictionaryList = dictionaryList
                                .map((listItem) => {
                                  const currentListItem =
                                    listItem.toLocaleLowerCase();
                                  const currentValueText =
                                    valueText.toLocaleLowerCase();

                                  if (currentListItem === currentValueText)
                                    return listItem;

                                  return null;
                                })
                                .filter(
                                  (listValueItem) => listValueItem !== null,
                                );

                              return {
                                text: checkDictionaryList[0] || "",
                                is_modified: true,
                              };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => !!valueItem.text)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );

                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                            .value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList =
                                  dictionaryList.filter((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    return currentListItem === currentValueText;
                                  });

                                return {
                                  text: checkDictionaryList[0],
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => !!valueItem.text)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text?.toLowerCase() ===
                                valueItem?.text?.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }

            return {
              ...item,
              attributionInfo: {
                attributionId:
                  item?.attributionInfo?.attributionId || createRandomString(8),
              },
              [currentShellKey]: {
                ...item[currentShellKey],
                attributionId:
                  item[currentShellKey]?.attributionId || createRandomString(8),
                value:
                  item[currentShellKey] &&
                  item[currentShellKey]?.value.length > valueIndex
                    ? item[currentShellKey].value
                        ?.map((valueItem, valueItemIndex) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        })
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...item[currentShellKey].value,
                        { text: valueText, is_modified: true },
                      ]
                        ?.map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            };
          }
          return item;
        }),
      },
    }),
  },
  [SECTION_KEYS.conferenceSchedule]: {
    [DRUG_PROFILE]: (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      [SECTION_KEYS.conferenceSchedule]: {
        ...data[SECTION_KEYS.conferenceSchedule],
        [DRUG_PROFILE]: data[SECTION_KEYS.conferenceSchedule]?.[
          DRUG_PROFILE
        ]?.map((item, index) => {
          const currentShellKey =
            shellKey as DrugProfileShellKeysOnlyEntryDataValue;
          if (index === tableIndex) {
            if (shellKey === DRUG_PROFILE_SHELL_KEYS.therapeuticArea) {
              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [DRUG_PROFILE_SHELL_KEYS.therapeuticArea]: {
                  ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea],
                  attributionId:
                    item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                      ?.attributionId || createRandomString(8),
                  value:
                    item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea] &&
                    item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]?.value
                      .length > valueIndex
                      ? item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              const checkDictionaryList = dictionaryList
                                .map((listItem) => {
                                  const currentListItem =
                                    listItem.toLocaleLowerCase();
                                  const currentValueText =
                                    valueText.toLocaleLowerCase();

                                  if (currentListItem === currentValueText)
                                    return listItem;

                                  return null;
                                })
                                .filter(
                                  (listValueItem) => listValueItem !== null,
                                );

                              return {
                                text: checkDictionaryList[0] || "",
                                is_modified: true,
                              };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => !!valueItem.text)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );

                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[DRUG_PROFILE_SHELL_KEYS.therapeuticArea]
                            .value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList =
                                  dictionaryList.filter((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    return currentListItem === currentValueText;
                                  });

                                return {
                                  text: checkDictionaryList[0],
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => !!valueItem.text)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text?.toLowerCase() ===
                                valueItem?.text?.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }

            return {
              ...item,
              attributionInfo: {
                attributionId:
                  item?.attributionInfo?.attributionId || createRandomString(8),
              },
              [currentShellKey]: {
                ...item[currentShellKey],
                attributionId:
                  item[currentShellKey]?.attributionId || createRandomString(8),
                value:
                  item[currentShellKey] &&
                  item[currentShellKey]?.value.length > valueIndex
                    ? item[currentShellKey].value
                        ?.map((valueItem, valueItemIndex) => {
                          if (valueItemIndex === valueIndex) {
                            if (valueText === "") {
                              return null;
                            }
                            return { text: valueText, is_modified: true };
                          }

                          return valueItem;
                        })
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        })
                    : [
                        ...item[currentShellKey].value,
                        { text: valueText, is_modified: true },
                      ]
                        ?.map(
                          (
                            valueItem: {
                              text: string;
                              is_modified: boolean;
                            },
                            valueItemIndex: number,
                          ) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          },
                        )
                        .filter((valueItem) => valueItem !== null)
                        .filter((valueItem, valueItemIndex, valueList) => {
                          const lastValueIndex = valueList.findIndex(
                            (target) =>
                              target?.text.toLowerCase() ===
                              valueItem?.text.toLowerCase(),
                          );
                          return valueItemIndex === lastValueIndex;
                        }),
              },
            };
          }
          return item;
        }),
      },
    }),
  },
  [SECTION_KEYS.ctg]: {
    "Drug Profile": (
      data: ArticleEntryData,
      tableIndex: number,
      tableKey: string | null,
      groupShellKey: string | null,
      groupShellIndex: number | null,
      subGroupShellIndex: number | null,
      shellKey: string,
      shellIndex: number,
      valueText: string,
      valueIndex: number,
      dictionaryList: string[],
    ) => ({
      ...data,
      [SECTION_KEYS.ctg]: {
        ...data[SECTION_KEYS.ctg],
        "Drug Profile": data[SECTION_KEYS.ctg]?.["Drug Profile"]?.map(
          (item, index) => {
            if (index === tableIndex) {
              if (shellKey === "Therapeutic Area") {
                return {
                  ...item,
                  attributionInfo: {
                    attributionId:
                      item?.attributionInfo?.attributionId ||
                      createRandomString(8),
                  },
                  "Therapeutic Area": {
                    ...item["Therapeutic Area"],
                    attributionId:
                      item["Therapeutic Area"]?.attributionId ||
                      createRandomString(8),
                    value:
                      item["Therapeutic Area"] &&
                      item["Therapeutic Area"]?.value.length > valueIndex
                        ? item["Therapeutic Area"].value
                            ?.map((valueItem, valueItemIndex) => {
                              if (valueItemIndex === valueIndex) {
                                const checkDictionaryList = dictionaryList
                                  .map((listItem) => {
                                    const currentListItem =
                                      listItem.toLocaleLowerCase();
                                    const currentValueText =
                                      valueText.toLocaleLowerCase();

                                    if (currentListItem === currentValueText)
                                      return listItem;

                                    return null;
                                  })
                                  .filter(
                                    (listValueItem) => listValueItem !== null,
                                  );

                                return {
                                  text: checkDictionaryList[0] || "",
                                  is_modified: true,
                                };
                              }

                              return valueItem;
                            })
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text.toLowerCase() ===
                                  valueItem?.text.toLowerCase(),
                              );

                              return valueItemIndex === lastValueIndex;
                            })
                        : [
                            ...item["Therapeutic Area"].value,
                            { text: valueText, is_modified: true },
                          ]
                            ?.map(
                              (
                                valueItem: {
                                  text: string;
                                  is_modified: boolean;
                                },
                                valueItemIndex: number,
                              ) => {
                                if (valueItemIndex === valueIndex) {
                                  const checkDictionaryList =
                                    dictionaryList.filter((listItem) => {
                                      const currentListItem =
                                        listItem.toLocaleLowerCase();
                                      const currentValueText =
                                        valueText.toLocaleLowerCase();

                                      return (
                                        currentListItem === currentValueText
                                      );
                                    });

                                  return {
                                    text: checkDictionaryList[0],
                                    is_modified: true,
                                  };
                                }

                                return valueItem;
                              },
                            )
                            .filter((valueItem) => !!valueItem.text)
                            .filter((valueItem, valueItemIndex, valueList) => {
                              const lastValueIndex = valueList.findIndex(
                                (target) =>
                                  target?.text?.toLowerCase() ===
                                  valueItem?.text?.toLowerCase(),
                              );
                              return valueItemIndex === lastValueIndex;
                            }),
                  },
                };
              }

              return {
                ...item,
                attributionInfo: {
                  attributionId:
                    item?.attributionInfo?.attributionId ||
                    createRandomString(8),
                },
                [shellKey as DrugProfileDefaultShellKey]: {
                  ...item[shellKey as DrugProfileDefaultShellKey],
                  attributionId:
                    item[shellKey as DrugProfileDefaultShellKey]
                      ?.attributionId || createRandomString(8),
                  value:
                    item[shellKey as DrugProfileDefaultShellKey] &&
                    item[shellKey as DrugProfileDefaultShellKey]?.value.length >
                      valueIndex
                      ? item[shellKey as DrugProfileDefaultShellKey].value
                          ?.map((valueItem, valueItemIndex) => {
                            if (valueItemIndex === valueIndex) {
                              if (valueText === "") {
                                return null;
                              }
                              return { text: valueText, is_modified: true };
                            }

                            return valueItem;
                          })
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          })
                      : [
                          ...item[shellKey as DrugProfileDefaultShellKey].value,
                          { text: valueText, is_modified: true },
                        ]
                          ?.map(
                            (
                              valueItem: {
                                text: string;
                                is_modified: boolean;
                              },
                              valueItemIndex: number,
                            ) => {
                              if (valueItemIndex === valueIndex) {
                                if (valueText === "") {
                                  return null;
                                }
                                return { text: valueText, is_modified: true };
                              }

                              return valueItem;
                            },
                          )
                          .filter((valueItem) => valueItem !== null)
                          .filter((valueItem, valueItemIndex, valueList) => {
                            const lastValueIndex = valueList.findIndex(
                              (target) =>
                                target?.text.toLowerCase() ===
                                valueItem?.text.toLowerCase(),
                            );
                            return valueItemIndex === lastValueIndex;
                          }),
                },
              };
            }
            return item;
          },
        ),
      },
    }),
  },
};
